// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg width=%2724%27 height=%2724%27 xmlns=%27http://www.w3.org/2000/svg%27 color=%27%23858585%27%3E%3Cg fill=%27currentcolor%27 fill-rule=%27evenodd%27%3E%3Ccircle cx=%275%27 cy=%2712%27 r=%272%27/%3E%3Ccircle cx=%2712%27 cy=%2712%27 r=%272%27/%3E%3Ccircle cx=%2719%27 cy=%2712%27 r=%272%27/%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flex {
  display: flex;
}

.inline-flex {
  display: inline-flex;
}

.flex-row {
  flex-direction: row;
}

.flex-col {
  flex-direction: column;
}

.items-start {
  align-items: flex-start;
}

.items-end {
  align-items: flex-end;
}

.items-center {
  align-items: center;
}

.items-baseline {
  align-items: baseline;
}

.items-stretch {
  align-items: stretch;
}

.justify-between {
  justify-content: space-between;
}

.justify-around {
  justify-content: space-around;
}

.justify-center {
  justify-content: center;
}

.justify-start {
  justify-content: flex-start;
}

.justify-end {
  justify-content: flex-end;
}

.flex-1 {
  flex: 1 1;
}

.flex-auto {
  flex: 1 1 auto;
}

.flex-none {
  flex: none;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.text-left {
  text-align: left;
}

.text-responsive {
  text-align: left;
  margin-top: 15px;
}

@media screen and (max-width: 776px) {
  .text-responsive {
    text-align: center;
    margin-top: 30px;
  }
}

.uppercase {
  text-transform: uppercase;
}

.hyphenate {
  word-wrap: break-word;
  hyphens: auto;
  overflow-wrap: break-word;
}

.no-wrap {
  white-space: nowrap;
}

.max-w-col-10,
.max-w-col-4,
.max-w-col-6,
.max-w-col-8 {
  width: 100%;
}

.max-w-col-4 {
  max-width: 24rem;
}

.max-w-col-6 {
  max-width: 36.75rem;
}

.max-w-col-8 {
  max-width: 49.5rem;
}

.max-w-col-10 {
  max-width: 62.25rem;
}

.faq__heading {
  color: #0000008c;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1rem;
  margin-bottom: 0;
  text-transform: uppercase;
}

.faq__items + .faq__heading {
  margin-top: 2.5rem;
}

.faq__item:not(:last-child) {
  border-bottom: 1px solid #00000014;
}

.faq__item__question {
  transition: color 0.25s cubic-bezier(0.19, 1, 0.22, 1);
}

@media percy, screen and (prefers-reduced-motion: reduce) {
  .faq__item__question {
    transition-duration: 1ms;
  }
}

.faq__item__question-inner {
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
  padding-bottom: 1.25rem;
  padding-top: 1.25rem;
  position: relative;
  width: 100%;
}

.faq__item__question-text {
  font-size: 1.0625rem;
  font-weight: 500;
  line-height: 1.5rem;
}

@media screen and (min-width: 1024px) {
  .faq__item__question-text {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

@media screen and (max-width: 767px) {
  .faq__item__question-text {
    font-size: 1.0625rem;
    line-height: 1.5rem;
  }
}

.faq__item__question__toggle {
  display: none;
}

.faq__item__answer {
  padding-bottom: 3rem;
}

.faq__item__answer h2,
.faq__item__answer h3,
.faq__item__answer h4 {
  font-size: 1.0625rem;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 1.5rem;
  margin-bottom: 1rem;
  margin-top: 0;
}

.faq__item__question__icon {
  appearance: none;
  background-color: initial;
  border: 0;
  border-radius: 0;
  height: 1.5rem;
  line-height: normal;
  margin: 0;
  padding: 0;
  position: relative;
  right: 0.5rem;
  width: 1.5rem;
}

.faq__item.is-active .faq__item__question,
.faq__item.is-inactive .faq__item__question,
.faq__item[data-toggleable] .faq__item__question {
  margin: 0;
  position: relative;
}

.faq__item.is-active .faq__item__question-text,
.faq__item.is-inactive .faq__item__question-text,
.faq__item[data-toggleable] .faq__item__question-text {
  padding-right: 2.5rem;
}

.faq__item.is-active .faq__item__question__toggle,
.faq__item.is-inactive .faq__item__question__toggle,
.faq__item[data-toggleable] .faq__item__question__toggle {
  align-items: center;
  appearance: none;
  background-color: initial;
  border: 0;
  border-radius: 0;
  bottom: 0;
  cursor: pointer;
  display: flex;
  left: 0;
  line-height: normal;
  margin: 0;
  padding: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
}

.faq__item.is-active .faq__item__question__icon:after,
.faq__item.is-active .faq__item__question__icon:before,
.faq__item.is-inactive .faq__item__question__icon:after,
.faq__item.is-inactive .faq__item__question__icon:before,
.faq__item[data-toggleable] .faq__item__question__icon:after,
.faq__item[data-toggleable] .faq__item__question__icon:before {
  background-color: #000;
  border-radius: 0.0625rem;
  content: "";
  height: 0.125rem;
  position: absolute;
  right: 0;
  transition: transform 0.4s cubic-bezier(0.19, 1, 0.22, 1),
    background-color 0.25s cubic-bezier(0.19, 1, 0.22, 1);
  width: 0.75rem;
}

@media percy, screen and (prefers-reduced-motion: reduce) {
  .faq__item.is-active .faq__item__question__icon:after,
  .faq__item.is-active .faq__item__question__icon:before,
  .faq__item.is-inactive .faq__item__question__icon:after,
  .faq__item.is-inactive .faq__item__question__icon:before,
  .faq__item[data-toggleable] .faq__item__question__icon:after,
  .faq__item[data-toggleable] .faq__item__question__icon:before {
    transition-duration: 1ms;
  }
}

@media screen and (min-width: 768px) {
  .faq__item.is-active .faq__item__question__icon:after,
  .faq__item.is-active .faq__item__question__icon:before,
  .faq__item.is-inactive .faq__item__question__icon:after,
  .faq__item.is-inactive .faq__item__question__icon:before,
  .faq__item[data-toggleable] .faq__item__question__icon:after,
  .faq__item[data-toggleable] .faq__item__question__icon:before {
    width: 0.875rem;
  }
}

.faq__item.is-active .faq__item__question__icon:after,
.faq__item.is-inactive .faq__item__question__icon:after,
.faq__item[data-toggleable] .faq__item__question__icon:after {
  transform: rotate(90deg);
}

.faq__item.is-active .faq__item__answer,
.faq__item.is-inactive .faq__item__answer,
.faq__item[data-toggleable] .faq__item__answer {
  display: none;
}

.faq__item.is-active .faq__item__answer {
  animation: fadeInDown 0.6s cubic-bezier(0.19, 1, 0.22, 1);
  display: block;
}

@media percy, screen and (prefers-reduced-motion: reduce) {
  .faq__item.is-active .faq__item__answer {
    animation: none;
  }
}

.faq__item.is-active .faq__item__question__icon:after,
.faq__item.is-active .faq__item__question__icon:before {
  transform: rotate(180deg);
}

.faq__section__icon {
  margin-bottom: 1rem;
}

@media screen and (max-width: 767px) {
  .faq__section__icon {
    display: none;
  }
}

.faq__section__heading {
  font-size: 2rem;
  font-weight: 900;
  line-height: 2.25rem;
  margin-bottom: 2.5rem;
}

@media screen and (min-width: 768px) {
  .faq__section__heading {
    font-size: 2.5rem;
    line-height: 3rem;
  }
}

@media screen and (min-width: 1024px) {
  .faq__section__heading {
    font-size: 3.5rem;
    line-height: 3.75rem;
  }
}

.faq__section__support-link {
  font-size: 1.5rem;
  font-weight: 500;
  font-weight: 700;
  line-height: 2rem;
  margin-top: 3rem;
}

@media screen and (max-width: 767px) {
  .faq__section__support-link {
    font-size: 1.25rem;
    font-weight: 700;
    line-height: 1.75rem;
  }
}

.faq-section__wrapper {
  padding-top: 3rem;
  position: relative;
}

@media screen and (max-width: 767px) {
  .faq-section__wrapper {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
}

@media screen and (min-width: 768px) {
  .faq-section__wrapper {
    column-gap: 1.5rem;
    display: grid;
    grid-template-areas: "header header content content content content";
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

@media screen and (min-width: 768px) and (min-width: 768px) {
  .faq-section__wrapper {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
}

@media screen and (min-width: 768px) and (min-width: 1024px) {
  .faq-section__wrapper {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}

@media screen and (min-width: 1024px) and (max-width: 1219px) {
  .faq-section__wrapper {
    grid-template-areas: "header header header . content content content content content content content content";
    grid-template-columns: repeat(12, 1fr);
  }
}

@media screen and (min-width: 1220px) {
  .faq-section__wrapper {
    grid-template-areas: ". header header . . content content content content content content content";
    grid-template-columns: repeat(12, 1fr);
  }
}

@media screen and (min-width: 768px) {
  .faq-section__header {
    display: flex;
    grid-area: header;
    height: fit-content;
    position: sticky;
  }
}

@media screen and (min-width: 1024px) and (max-width: 1219px) {
  .faq-section__header {
    margin-left: 2rem;
  }
}

@media screen and (min-width: 768px) {
  .faq-section__header--has-border {
    height: fit-content;
    position: relative;
    width: fit-content;
  }
}

@media screen and (min-width: 768px) and (min-width: 768px) and (max-width: 1023px) {
  .faq-section__header--has-border {
    padding-left: 0.375rem;
  }
}

@media screen and (min-width: 768px) {
  .faq-section__header--has-border .faq-section__header__heading {
    line-height: 2.5rem;
    margin-bottom: 0;
    padding-left: 0.375rem;
    padding-right: 0.625rem;
    width: min-content;
  }
}

@media screen and (min-width: 1024px) {
  .faq-section__header--sticky {
    position: sticky;
    top: 1.25rem;
  }
}

@media screen and (max-width: 767px) {
  .faq-section__header--has-border .skpabloo-selection-box {
    display: none;
  }
}

.faq-section__header__heading {
  font-size: 2rem;
  font-weight: 700;
  letter-spacing: -0.03125rem;
  line-height: 2.25rem;
  margin-top: 0;
}

@media screen and (max-width: 767px) {
  .faq-section__header__heading {
    font-size: 1.75rem;
    line-height: 2rem;
  }
}

.faq-section__header__blurb {
  font-size: 1.0625rem;
  font-weight: 300;
  line-height: 1.5rem;
  margin-top: 1rem;
}

@media screen and (max-width: 767px) {
  .faq-section__header__blurb {
    margin-bottom: 2.5rem;
  }
}

.faq-section__content {
  grid-area: content;
}

@media screen and (min-width: 768px) {
  .faq-section__content {
    padding-right: 2rem;
  }
}

@media screen and (max-width: 767px) {
  .faq-section__item__answer {
    font-size: 1rem;
    font-weight: 300;
    line-height: 1.5rem;
  }
}

.faq-section__support {
  font-size: 1.25rem;
  font-weight: 700;
  font-weight: 500;
  line-height: 1.5rem;
  margin-top: 3rem;
}

.faq-section__support__action {
  margin-top: 1rem;
}

.faq-section__support__action:after {
  vertical-align: text-bottom;
}

.education-banner {
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 1px 2px #00000014, 0 4px 8px #00000005, 0 0 4px #00000014;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  overflow: hidden;
  padding: 2.5rem 1.25rem;
  position: relative;
}

@media screen and (min-width: 768px) {
  .education-banner {
    padding: 2rem;
  }
}

.education-banner__text {
  z-index: 10;
}

@media screen and (max-width: 767px) {
  .education-banner__text {
    width: 100%;
  }
}

.education-banner__title {
  font-size: 2rem;
  font-weight: 700;
  letter-spacing: -0.5px;
  line-height: 2.5rem;
  text-align: center;
  text-transform: capitalize;
}

@media screen and (min-width: 768px) {
  .education-banner__title {
    text-align: left;
    text-transform: none;
  }
}

.education-banner__title .highlight {
  -webkit-text-fill-color: #0000;
  -webkit-background-clip: text;
  background-clip: text;
  background-color: #ffb387;
  background-repeat: no-repeat;
  background-size: cover;
  font-family: Caveat, Marfa, system-ui, -apple-system, BlinkMacSystemFont,
    Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 2.5rem;
  letter-spacing: -0.03125rem;
  line-height: 2.5rem;
}

@media screen and (max-width: 767px) {
  .education-banner__title .highlight {
    display: block;
    width: 100%;
  }
}

.education-banner__blurb {
  font-size: 1.0625rem;
  font-weight: 300;
  line-height: 1.5rem;
  margin-bottom: 1.5rem;
  margin-top: 1rem;
  text-align: center;
  width: 100%;
}

@media screen and (min-width: 768px) {
  .education-banner__blurb {
    margin-bottom: 0;
    margin-top: 0.5rem;
    text-align: left;
  }
}

.education-banner__cta {
  align-self: center;
}

@media screen and (max-width: 767px) {
  .education-banner__cta {
    margin: 0 auto;
  }
}

.education-banner__image {
  position: absolute;
}

@media screen and (min-width: 768px) {
  .education-banner__image {
    bottom: -1.5625rem;
    right: 7.375rem;
    width: 14.5rem;
  }
}

@media screen and (min-width: 1024px) {
  .education-banner__image {
    bottom: -1.5625rem;
    right: 7.375rem;
  }
}

@media screen and (min-width: 1220px) {
  .education-banner__image {
    bottom: -1.4375rem;
    right: 7rem;
  }
}

.tabs {
  background-color: #ebebeb;
  border-radius: 12px;
  display: inline-flex;
  padding: 0.125rem;
}

.tabs__button {
  appearance: none;
  background-color: initial;
  border: 0;
  border-radius: 0;
  border-radius: 0.625rem;
  color: #000000a3;
  display: block;
  font-size: 1rem;
  font-weight: 500;
  line-height: normal;
  line-height: 1.5rem;
  margin: 0;
  padding: 0.375rem 1rem;
}

.tabs__button:hover {
  color: #212123;
}

.tabs__button:not(:last-child) {
  margin-right: 0.125rem;
}

.tabs__button--active {
  background-color: #fff;
  box-shadow: 0 1px 1px #00000014;
  color: #212123;
}

.callout-simple {
  background-color: #f5f5f5;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  padding: 1.25rem 1.25rem 2rem;
}

@media screen and (min-width: 768px) {
  .callout-simple {
    flex-direction: row;
  }
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
  .callout-simple {
    flex-wrap: wrap;
    justify-content: flex-start;
  }
}

@media screen and (min-width: 1024px) {
  .callout-simple {
    justify-content: center;
    padding: 1.25rem 1.5625rem;
  }
}

.callout-simple__icon {
  margin-bottom: 0.5rem;
  vertical-align: initial;
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
  .callout-simple__icon {
    width: 100%;
  }
}

@media screen and (min-width: 1024px) {
  .callout-simple__icon {
    margin-bottom: 0;
    margin-right: 0.5rem;
  }
}

.callout-simple__text {
  color: #212123;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5rem;
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
  .callout-simple__text {
    max-width: 40rem;
  }
}

.get-started-sticker {
  margin-bottom: 4rem;
  margin-top: 4rem;
}

@media screen and (min-width: 1024px) {
  .get-started-sticker {
    margin-bottom: 6rem;
    margin-top: 6rem;
  }
}

.get-started-sticker--no-margins {
  margin-bottom: 0;
  margin-top: 0;
}

.get-started-sticker--with-divider .wrapper {
  padding-top: 4rem;
  position: relative;
}

.get-started-sticker--with-divider .wrapper:before {
  border-top: 1px solid #00000014;
  content: "";
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}

@media screen and (min-width: 1024px) {
  .get-started-sticker--with-divider .wrapper {
    padding-top: 6rem;
  }
}

.get-started-sticker__sticker {
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  display: block;
  height: 7.75rem;
  margin: 0 auto 1.5rem;
  -webkit-mask-image: -webkit-radial-gradient(#fff, #000);
  width: 7.75rem;
}

.get-started-sticker__heading {
  font-size: 1.75rem;
  font-weight: 700;
  letter-spacing: -0.5px;
  line-height: 2.75rem;
  margin: 0 auto 2rem;
  max-width: 20.5rem;
  text-align: center;
}

@media screen and (min-width: 768px) {
  .get-started-sticker__heading {
    font-size: 2.75rem;
    letter-spacing: -1px;
    line-height: 3.5rem;
    margin-bottom: 2.25rem;
    max-width: 32.5rem;
  }
}

@media screen and (min-width: 1024px) {
  .get-started-sticker__heading {
    max-width: 36.75rem;
  }
}

.get-started-sticker__heading em {
  color: #f26725;
  display: block;
  font-family: Caveat, Marfa, system-ui, -apple-system, BlinkMacSystemFont,
    Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 2.75rem;
  font-weight: 700;
  line-height: 2rem;
}

@media screen and (min-width: 768px) {
  .get-started-sticker__heading em {
    font-size: 3.5rem;
    letter-spacing: -1px;
    margin-top: 0.5rem;
  }
}

.get-started-sticker__blurb {
  font-size: 1.0625rem;
  font-weight: 300;
  line-height: 1.5rem;
  margin: 0 auto 1.5rem;
  max-width: 18rem;
  text-align: center;
}

@media screen and (min-width: 1024px) {
  .get-started-sticker__blurb {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

@media screen and (min-width: 768px) {
  .get-started-sticker__blurb {
    max-width: 29.5rem;
  }
}

@media screen and (min-width: 1024px) {
  .get-started-sticker__blurb {
    margin: 0 auto 1.5rem;
    max-width: 32.5rem;
    max-width: 36.75rem;
  }
}

.get-started-sticker__actions {
  text-align: center;
}

.artboard.pitch .artboard__body {
  padding: 2rem 1.25rem;
}

@media screen and (min-width: 768px) {
  .artboard.pitch .artboard__body {
    padding: 3.5rem;
  }
}

.pill {
  background-color: #00000014;
  border-radius: 6px;
  color: #000000b3;
  display: inline-block;
  font-size: 0.6875rem;
  font-weight: 600;
  line-height: 0;
  padding: 0.75rem 0.5rem;
  text-transform: uppercase;
}

.pill.pill--yellow {
  background-color: #f5a925;
  color: #000c;
}

.pill.pill--feature {
  margin-left: 0.25rem;
  position: relative;
  top: -0.1875rem;
}

.pill.pill--orange {
  background-color: #f26725;
  color: #fff;
}

.pill--secondary {
  background-color: #ebebeb;
  color: #000000a3;
}

.pill--rainbow {
  background: linear-gradient(
    90deg,
    #e8b8fc,
    #e7db8f 35%,
    #a6f1e8 69%,
    #88fccf
  );
  color: #212123;
  text-transform: uppercase;
}

.pill--round {
  background-color: #00000014;
  border-radius: 6px;
  border-radius: 9999px;
  color: #000000b3;
  font-size: 0.6875rem;
  font-weight: 600;
  line-height: 0;
  min-width: 1.25rem;
  padding: 0.625rem 0.375rem;
  text-transform: uppercase;
}

.pill--round,
.pill-link {
  display: inline-block;
}

.pill-link:hover .pill {
  color: #212123;
}

.skpabloo-selection-box {
  border: 1px solid #f26725;
  bottom: -0.1875rem;
  left: -0.1875rem;
  position: absolute;
  right: -0.1875rem;
  top: -0.1875rem;
  z-index: -1;
}

.skpabloo-selection-box__inner-box {
  background-clip: padding-box;
  background-color: #fff;
  border: 0.5px solid #00000040;
  box-shadow: 0 1px 2px #0003;
  height: 6px;
  position: absolute;
  width: 6px;
}

.skpabloo-selection-box__inner-box-top-left {
  left: -4px;
  top: -4px;
}

.skpabloo-selection-box__inner-box-top-right {
  right: -4px;
  top: -4px;
}

.skpabloo-selection-box__inner-box-bottom-left {
  bottom: -4px;
  left: -4px;
}

.skpabloo-selection-box__inner-box-bottom-right {
  bottom: -4px;
  right: -4px;
}

.skpabloo-selection-box--crosses {
  border: 0.5px solid #f26725;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
}

.skpabloo-selection-box--crosses .skpabloo-selection-box__inner-box {
  background: none;
  border: none;
  box-shadow: none;
}

.skpabloo-selection-box--crosses .skpabloo-selection-box__inner-box:after,
.skpabloo-selection-box--crosses .skpabloo-selection-box__inner-box:before {
  background: #f26725;
  content: "";
  display: block;
  height: 8px;
  position: absolute;
  width: 0.5px;
}

.skpabloo-selection-box--crosses .skpabloo-selection-box__inner-box:before {
  transform: rotate(45deg);
}

.skpabloo-selection-box--crosses .skpabloo-selection-box__inner-box:after {
  transform: rotate(135deg);
}

.skpabloo-selection-box--crosses .skpabloo-selection-box__inner-box-top-left {
  left: -1px;
  top: -4.5px;
}

.skpabloo-selection-box--crosses .skpabloo-selection-box__inner-box-top-right {
  right: -6px;
  top: -4.5px;
}

.skpabloo-selection-box--crosses .skpabloo-selection-box__inner-box-bottom-left {
  bottom: -2px;
  left: -0.5px;
}

.skpabloo-selection-box--crosses .skpabloo-selection-box__inner-box-bottom-right {
  bottom: -2px;
  right: -6px;
}

.artboard {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  position: relative;
  will-change: transform;
}

@media screen and (min-width: 1024px) {
  .artboard--fixed {
    position: absolute;
  }
}

.artboard--symbol .artboard__name {
  color: #b620e0;
}

.artboard__name {
  align-items: center;
  color: #858585;
  cursor: default;
  display: flex;
  font-size: 0.75rem;
  gap: 0.25rem;
  letter-spacing: -0.4px;
  line-height: 1rem;
  margin-bottom: 0.25rem;
  margin-left: 0.25rem;
}

.artboard:not(.artboard--selected) .artboard__name:hover + .artboard__body {
  position: relative;
}

.artboard:not(.artboard--selected)
  .artboard__name:hover
  + .artboard__body:before {
  background-color: initial;
  border: 2px solid #f26725;
  bottom: 0;
  content: "";
  display: block;
  height: 100%;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
}

.artboard__body {
  background-color: #fff;
  box-shadow: 0 0 2px #0000001a, 0 2px 4px #0000001a;
}

.artboard--selected,
.artboard__body {
  position: relative;
}

.artboard--selected .artboard__body {
  border: 0.5px solid #f26725;
}

.artboard--selected .artboard__body:after,
.artboard--selected .artboard__body:before {
  background-color: #fff;
  border: 0.5px solid #00000040;
  box-shadow: 0 1px 2px #0003;
  content: "";
  display: block;
  height: 0.5rem;
  position: absolute;
  width: 0.5rem;
}

.artboard--selected .artboard__body:before {
  left: -0.25rem;
  top: -0.25rem;
}

.artboard--selected .artboard__body:after {
  right: -0.25rem;
  top: -0.25rem;
}

@media screen and (min-width: 1024px) {
  .artboard--selected .artboard__body {
    border: 0;
    outline: 0.5px solid #f26725;
  }
}

.artboard--selected:after,
.artboard--selected:before {
  background-color: #fff;
  border: 0.5px solid #00000040;
  box-shadow: 0 1px 2px #0003;
  content: "";
  display: block;
  height: 0.5rem;
  position: absolute;
  width: 0.5rem;
  z-index: 10;
}

.artboard--selected:before {
  bottom: -0.25rem;
  left: -0.25rem;
}

.artboard--selected:after {
  bottom: -0.25rem;
  right: -0.25rem;
}

.artboard--moving .artboard__body:after,
.artboard--moving .artboard__body:before,
.artboard--moving:after,
.artboard--moving:before {
  display: none;
}

.artboard__asset {
  display: block;
}

@media screen and (max-width: 1023px) {
  .artboard__asset {
    max-width: 100%;
  }
}

.artboard--full-width .artboard__body {
  width: 100%;
}

.annotation {
  display: none;
}

@media screen and (min-width: 1024px) {
  .annotation {
    display: block;
    z-index: 1;
  }
}

.annotation kbd {
  align-items: center;
  background-color: #fff;
  border: 1px solid #ebebeb;
  border-radius: 8px;
  box-shadow: 0 1px 0 0 #ccc;
  color: #212123;
  display: inline-flex;
  font-family: inherit;
  font-size: 0.875rem;
  font-weight: 600;
  justify-content: center;
  line-height: 1rem;
  min-height: 1.25rem;
  min-width: 1.5rem;
  padding: 0 0.3125rem;
}

.annotation kbd:not(.annotation kbd:last-of-type) {
  margin-right: 0.25rem;
}

.annotation__icon {
  align-items: center;
  background-color: #f26725;
  border-radius: 9999px;
  box-shadow: 0 0 0 2px #fff, 0 0 0 3px #00000014, 0 1px 2px 4px #00000014;
  display: block;
  height: 0.875rem;
  left: 0.5rem;
  position: absolute;
  transform: translate3d(-50%, -50%, 0);
  width: 0.875rem;
  z-index: 1;
}

.annotation__icon:hover {
  cursor: pointer;
  height: 1rem;
  width: 1rem;
}

.annotation__icon:active {
  cursor: move;
}

.annotation__popup {
  background-clip: padding-box;
  background-color: #fff;
  border: 1px solid #0000001a;
  border-radius: 12px;
  box-shadow: 0 8px 16px #0000001a;
  display: none;
  left: 0.5rem;
  position: absolute;
  top: 0;
  width: 18.4375rem;
}

.annotation__popup.is-visible {
  animation: slideDown 0.4s cubic-bezier(0.19, 1, 0.22, 1);
}

@keyframes slideDown {
  0% {
    opacity: 0;
    transform: translateY(-5px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.annotation--active {
  z-index: 10;
}

.annotation--active .annotation__icon {
  height: 1.375rem;
  width: 1.375rem;
}

.annotation--active .annotation__popup {
  display: block;
}

.annotation--was-active .annotation__icon {
  background-color: #000000b3;
}

.annotation--moving .annotation__icon:hover {
  cursor: move;
}

.annotation--moving .annotation__popup {
  display: none;
}

.annotation__header {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: top 1rem right 1rem;
  background-repeat: no-repeat;
  background-size: 1rem;
  border-bottom: 1px solid #0000001a;
  padding: 1.125rem 1.3125rem 1.0625rem 1.25rem;
}

.annotation__header:last-child {
  border-bottom: none;
}

.annotation__content {
  background-color: #00000005;
  padding: 1.125rem 1.25rem 1.25rem;
}

.annotation__comment {
  list-style: none;
}

.annotation__comment:not(:last-of-type) {
  margin-bottom: 1.375rem;
}

.annotation__meta {
  align-items: center;
  display: flex;
  margin-bottom: 0.25rem;
}

.annotation__avatar {
  border-radius: 9999px;
  height: 1rem;
  margin-right: 0.5rem;
  width: 1rem;
}

.annotation__author {
  color: #000;
  font-size: 0.8125rem;
  font-weight: 500;
  line-height: 1rem;
}

.annotation__timestamp {
  color: #000000a3;
  font-size: 0.75rem;
  line-height: 1rem;
  margin-left: 0.5rem;
}

.annotation__text {
  color: #5c5c5c;
  font-size: 0.8125rem;
  line-height: 1.1875rem;
}

.annotation__text strong {
  font-weight: 600;
}

.annotation__text em {
  font-style: italic;
}

.entrance:not(.is-visible) {
  opacity: 0;
}

.sticker-link {
  text-align: center;
}

@media screen and (min-width: 1024px) {
  .sticker-link {
    align-items: center;
    column-gap: 1.5rem;
    display: flex;
    text-align: left;
  }
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
  .sticker-link {
    line-height: 1.75rem;
  }
}

@media screen and (max-width: 1023px) {
  .sticker-link__image {
    margin-bottom: 1rem;
  }
}

.sticker-link__text {
  text-wrap: balance;
}

@media screen and (max-width: 767px) {
  .sticker-link__text {
    margin-left: auto;
    margin-right: auto;
    max-width: 25rem;
  }
}

.sticker-links-section__wrapper {
  column-gap: 1.5rem;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

@media screen and (min-width: 768px) {
  .sticker-links-section__wrapper {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
}

@media screen and (min-width: 1024px) {
  .sticker-links-section__wrapper {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}

@media screen and (max-width: 767px) {
  .sticker-links-section__wrapper {
    gap: 4rem;
  }
}

.sticker-links-section__wrapper .sticker-link {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

@media screen and (min-width: 1024px) {
  .sticker-links-section__wrapper .sticker-link {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}

.sticker-links-section__wrapper .sticker-link:first-child {
  grid-column: 1 / span 4;
}

@media screen and (min-width: 768px) {
  .sticker-links-section__wrapper .sticker-link:first-child {
    grid-column: 1 / span 3;
  }
}

@media screen and (min-width: 1024px) {
  .sticker-links-section__wrapper .sticker-link:first-child {
    grid-column: 1 / span 6;
  }
}

@media screen and (min-width: 1220px) {
  .sticker-links-section__wrapper .sticker-link:first-child {
    grid-column: 2 / span 5;
  }
}

.sticker-links-section__wrapper .sticker-link:last-child {
  grid-column: 1 / span 4;
}

@media screen and (min-width: 768px) {
  .sticker-links-section__wrapper .sticker-link:last-child {
    grid-column: 4 / span 3;
  }
}

@media screen and (min-width: 1024px) {
  .sticker-links-section__wrapper .sticker-link:last-child {
    grid-column: 7 / span 6;
  }
}

@media screen and (min-width: 1220px) {
  .sticker-links-section__wrapper .sticker-link:last-child {
    grid-column: 7 / span 5;
  }
}

.sticker-links-section.three_items_variant .sticker-link {
  display: unset;
  padding: 0;
  text-align: center;
}

@media screen and (min-width: 1220px) {
  .sticker-links-section.three_items_variant .sticker-link {
    align-items: center;
    column-gap: 1.5rem;
    display: flex;
    text-align: left;
  }
}

.sticker-links-section.three_items_variant .sticker-link:first-child {
  grid-column: 1 / span 4;
}

@media screen and (min-width: 768px) {
  .sticker-links-section.three_items_variant .sticker-link:first-child {
    grid-column: 1 / span 2;
  }
}

@media screen and (min-width: 1024px) {
  .sticker-links-section.three_items_variant .sticker-link:first-child {
    grid-column: 1 / span 4;
  }
}

@media screen and (min-width: 1220px) {
  .sticker-links-section.three_items_variant .sticker-link:first-child {
    grid-column: 1 / span 4;
  }
}

.sticker-links-section.three_items_variant .sticker-link:nth-child(2) {
  grid-column: 1 / span 4;
}

@media screen and (min-width: 768px) {
  .sticker-links-section.three_items_variant .sticker-link:nth-child(2) {
    grid-column: 3 / span 2;
  }
}

@media screen and (min-width: 1024px) {
  .sticker-links-section.three_items_variant .sticker-link:nth-child(2) {
    grid-column: 5 / span 4;
  }
}

@media screen and (min-width: 1220px) {
  .sticker-links-section.three_items_variant .sticker-link:nth-child(2) {
    grid-column: 5 / span 4;
  }
}

.sticker-links-section.three_items_variant .sticker-link:last-child {
  grid-column: 1 / span 4;
}

@media screen and (min-width: 768px) {
  .sticker-links-section.three_items_variant .sticker-link:last-child {
    grid-column: 5 / span 2;
  }
}

@media screen and (min-width: 1024px) {
  .sticker-links-section.three_items_variant .sticker-link:last-child {
    grid-column: 9 / span 4;
  }
}

@media screen and (min-width: 1220px) {
  .sticker-links-section.three_items_variant .sticker-link:last-child {
    grid-column: 9 / span 4;
  }
}

.top-bar {
  background-color: #fff;
  border-bottom: 1px solid #e6e6e6;
  padding-bottom: 0.75rem;
  padding-top: 0.75rem;
  position: fixed;
  text-align: center;
  top: 0;
  transition: transform 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  visibility: hidden;
  width: 100%;
  z-index: 100;
}

@media percy, screen and (prefers-reduced-motion: reduce) {
  .top-bar {
    transition-duration: 1ms;
  }
}

@media screen and (max-width: 1023px) {
  .top-bar {
    top: calc(4rem - 1px);
  }
}

@supports (
  (backdrop-filter: blur(1px))
) {
  .top-bar {
    backdrop-filter: blur(10px);
    background-color: #ffffffd9;
  }
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
  .comparison-table {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
}

@media screen and (min-width: 768px) and (max-width: 1023px) and (min-width: 1024px) {
  .comparison-table {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}

.comparison-table__row td:first-child,
.comparison-table__row th:first-child {
  border-radius: 6px 0 0 6px;
}

.comparison-table__row td:last-child,
.comparison-table__row th:last-child {
  border-radius: 0 6px 6px 0;
}

.comparison-table__row:nth-child(odd) {
  background: #fff;
}

.comparison-table__row__cell,
.comparison-table__row__heading {
  font-size: 0.9375rem;
  line-height: 1.5rem;
}

@media screen and (min-width: 1024px) {
  .comparison-table__row__cell,
  .comparison-table__row__heading {
    font-size: 1rem;
  }
}

.comparison-table__row__heading {
  padding: 1rem 0 1rem 1.25rem;
  text-align: left;
  vertical-align: middle;
}

@media screen and (min-width: 1024px) {
  .comparison-table__row__heading {
    padding: 1rem 1.25rem;
  }
}

.comparison-table__row__heading .tooltip {
  margin-left: 0.25rem;
}

.comparison-table__row__heading .tooltip svg {
  color: #000;
  vertical-align: middle;
}

.comparison-table__row__heading .tooltip svg #background {
  fill: #000;
  opacity: 0.096;
  transition: 0.25s cubic-bezier(0.455, 0.03, 0.515, 0.955);
}

.comparison-table__row__heading .pill {
  margin-left: 0.25rem;
}

.comparison-table__row__cell {
  font-size: 0.9375rem;
  padding: 1rem 0;
  text-align: center;
  vertical-align: top;
  width: 5.0625rem;
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
  .comparison-table__row__cell {
    width: 8.25rem;
  }
}

@media screen and (min-width: 1024px) {
  .comparison-table__row__cell {
    border-left: 1px solid #00000014;
    vertical-align: middle;
    width: 15rem;
  }
}

@media screen and (min-width: 1220px) {
  .comparison-table__row__cell {
    width: 16.75rem;
  }
}

.comparison-table__row__cell:not(.comparison-table__plan) {
  color: #0000007a;
}

.comparison-table__row__cell svg {
  color: #fff;
  vertical-align: middle;
}

.comparison-table__row__cell--color-grey:not(.comparison-table__plan) {
  color: #5c5c5c;
}

.comparison-table__title {
  font-size: 2rem;
  font-weight: 600;
  letter-spacing: -0.5px;
  line-height: 2.5rem;
  text-align: left;
}

@media screen and (min-width: 1220px) {
  .comparison-table__title {
    font-size: 2.25rem;
  }
}

.comparison-table__header {
  width: 100%;
}

.comparison-table__header .comparison-table__row {
  background: #0000;
}

.comparison-table__block {
  margin-bottom: 1.5rem;
  width: 100%;
}

.comparison-table__block:last-child {
  margin-bottom: 0;
}

.comparison-table__block:nth-child(2)
  .comparison-table__block__header
  .comparison-table__row__cell {
  border-left: 1px solid #00000014;
}

.comparison-table__block:not(.comparison-table__block--design)
  .comparison-table__block__header
  .comparison-table__row__cell {
  border: 0;
}

.comparison-table__block__title {
  padding: 1rem 1.25rem;
}

@media screen and (min-width: 768px) {
  .comparison-table__block__title {
    padding: 1rem;
  }
}

.comparison-table__block__title h3 {
  font-size: 1.125rem;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 1.5rem;
  margin: 0;
  text-align: left;
}

@media screen and (min-width: 768px) {
  .comparison-table__block__title h3 {
    font-size: 1.25rem;
  }
}

.comparison-table__plan {
  padding: 0 0.75rem 1.5rem;
  text-align: left;
}

.comparison-table__plan:first-of-type .button {
  background-color: #f26725;
}

.comparison-table__plan__name,
.comparison-table__plan__price {
  font-weight: 600;
}

.comparison-table__plan__name {
  font-size: 1rem;
  line-height: 1.5rem;
}

.comparison-table__plan__price {
  font-size: 1.25rem;
  line-height: 1.75rem;
  margin: 0.25rem 0;
}

@media screen and (min-width: 768px) {
  .comparison-table__plan__price {
    display: block;
  }
}

.comparison-table__plan__billing-mode {
  color: #000000a3;
  display: block;
  font-size: 0.9375rem;
  line-height: 1.25rem;
}

.comparison-table__plan .button {
  margin-top: 1.5rem;
  width: 100%;
}

.comparison-table__mobile-header__top-bar-title {
  color: #5c5c5c;
  display: none;
  font-size: 1rem;
  line-height: 1.5rem;
}

.comparison-table__mobile-header__title {
  font-size: 2rem;
  font-weight: 600;
  letter-spacing: -0.5px;
  line-height: 2.5rem;
  margin-bottom: 1.5rem;
  text-align: center;
}

@media screen and (max-width: 767px) {
  .comparison-table__mobile-header__title {
    font-size: 1.75rem;
    line-height: 2rem;
  }
}

.comparison-table__mobile-header__plans {
  align-items: center;
  display: flex;
  gap: 0.875rem;
  justify-content: flex-end;
  width: 100%;
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
  .comparison-table__mobile-header__plans {
    gap: 3.875rem;
  }
}

.comparison-table__mobile-header__plan-name {
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5rem;
}

.comparison-table__mobile-header__inner {
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.comparison-table--static .comparison-table__mobile-header__inner {
  padding: 1.25rem 0.25rem 1.25rem 0;
  position: relative;
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
  .comparison-table--static .comparison-table__mobile-header__inner {
    padding-right: 1.875rem;
  }
}

.comparison-table--static .comparison-table__mobile-header__inner:after {
  border-bottom: 1px solid #00000014;
  bottom: 0;
  content: "";
  left: -1rem;
  position: absolute;
  width: calc(100% + 2rem);
}

.comparison-table__note {
  color: #0000007a;
  display: block;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1rem;
  text-transform: uppercase;
  text-transform: none;
}

.comparison-table .tooltip.tooltip--new:before {
  background-color: #000c;
  max-width: 12.5rem;
  white-space: normal;
  width: max-content;
}

@media screen and (min-width: 1024px) {
  .comparison-table .tooltip.tooltip--new:before {
    max-width: 18.75rem;
  }
}

@media screen and (min-width: 1220px) {
  .comparison-table .tooltip.tooltip--new:before {
    max-width: 21.875rem;
  }
}

@media screen and (min-width: 1024px) and (max-width: 1219px) {
  .comparison-table--static
    .comparison-table__header
    .comparison-table__row__cell:last-child
    .button {
    margin-top: 2.75rem;
  }
}

.comparison-table--top-bar .comparison-table__title {
  font-size: 1.5rem;
  line-height: 2rem;
  padding-top: 1.5rem;
}

.comparison-table--top-bar .comparison-table__plan {
  padding-top: 1.5rem;
}

.comparison-table--top-bar .comparison-table__plan__name {
  font-size: 1rem;
}

.comparison-table--top-bar .comparison-table__plan__price {
  font-size: 1.25rem;
}

.comparison-table--top-bar .button {
  margin-top: 1rem;
}

@media screen and (min-width: 1024px) {
  .comparison-table--no-ctas .comparison-table__row__cell {
    width: 12.5rem;
  }
}

@media screen and (min-width: 768px) {
  .comparison-table--no-ctas .comparison-table__title {
    font-size: 1.5rem;
    font-weight: 600;
    line-height: 2rem;
  }
}

.comparison-table--no-ctas .comparison-table__plan {
  vertical-align: top;
}

.comparison-table--no-ctas .comparison-table__plan .button {
  display: none;
}

@media screen and (min-width: 768px) {
  .comparison-table--docs {
    padding: 0;
  }
}

.comparison-table--docs .comparison-table__row:nth-child(odd) {
  background: #fafafa;
}

.comparison-table--docs .comparison-table__header .comparison-table__row {
  background: #0000;
}

@media screen and (max-width: 767px) {
  .comparison-table--docs .tooltip.tooltip--new:before {
    max-width: 9.375rem;
  }
}

@media screen and (min-width: 1024px) and (max-width: 1219px) {
  .comparison-table--docs .tooltip.tooltip--new:before {
    max-width: 9.375rem;
  }
}

.top-bar--comparison-table .comparison-table__mobile-header__title {
  display: none;
}

.top-bar--comparison-table .comparison-table__mobile-header__plans {
  width: auto;
}

.top-bar--comparison-table .comparison-table__mobile-header__inner {
  padding: 1.25rem 1.25rem 1.25rem 1rem;
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
  .top-bar--comparison-table .comparison-table__mobile-header__inner {
    padding-left: 2.75rem;
    padding-right: 4.625rem;
  }
}

.top-bar--comparison-table .comparison-table__mobile-header__top-bar-title {
  display: block;
}

@media screen and (min-width: 1024px) {
  .comparison-table-grid {
    column-gap: 1.5rem;
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

@media screen and (min-width: 1024px) and (min-width: 768px) {
  .comparison-table-grid {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
}

@media screen and (min-width: 1024px) and (min-width: 1024px) {
  .comparison-table-grid {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}

@media screen and (max-width: 1219px) {
  .comparison-table-grid {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

@media screen and (max-width: 1219px) and (min-width: 640px) {
  .comparison-table-grid {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}

@media screen and (max-width: 1219px) and (min-width: 1220px) {
  .comparison-table-grid {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}

.comparison-table-grid .comparison-table {
  grid-column: 1 / span 4;
}

@media screen and (min-width: 768px) {
  .comparison-table-grid .comparison-table {
    grid-column: 1 / span 6;
  }
}

@media screen and (min-width: 1024px) and (max-width: 1219px) {
  .comparison-table-grid .comparison-table {
    grid-column: 1 / span 12;
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
}

@media screen and (min-width: 1024px) and (max-width: 1219px) and (min-width: 1024px) {
  .comparison-table-grid .comparison-table {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}

@media screen and (min-width: 1220px) {
  .comparison-table-grid .comparison-table {
    grid-column: 2 / span 10;
    padding: 0;
  }
}

.comparison-table-grid--has-blur {
  max-height: 43.75rem;
  overflow: hidden;
  position: relative;
  transition: max-height 0.4s cubic-bezier(0.455, 0.03, 0.515, 0.955);
}

.comparison-table-grid--has-blur.is-expanded {
  max-height: 218.75rem;
}

@media screen and (min-width: 1024px) {
  .comparison-table-grid--has-blur.is-expanded {
    max-height: 175rem;
  }
}

.comparison-table-grid--has-blur.is-expanded .comparison-table__blur {
  display: none;
}

.comparison-table-grid--docs {
  padding: 0;
}

@media screen and (min-width: 1024px) {
  .comparison-table-grid--docs {
    margin: 3.5rem 0;
  }
}

.comparison-table-grid--docs .comparison-table__blur {
  background-image: linear-gradient(0deg, #fff, #0000);
}

@media screen and (min-width: 1024px) {
  .comparison-table-grid--docs .comparison-table {
    grid-column: 1 / span 12;
    padding: 0;
  }
}

.comparison-table-grid--docs .comparison-table__mobile-header__title a {
  display: none;
}

.comparison-table-grid--docs.is-expanded {
  max-height: 231.25rem;
}

@media screen and (min-width: 768px) {
  .comparison-table-grid--docs.is-expanded {
    max-height: 181.25rem;
  }
}

@media screen and (min-width: 1024px) {
  .comparison-table-grid--docs.is-expanded {
    max-height: 212.5rem;
  }
}

@media screen and (min-width: 1220px) {
  .comparison-table-grid--docs.is-expanded {
    max-height: 193.75rem;
  }
}

.comparison-table-grid--docs .comparison-table__row__heading {
  font-weight: 400;
}

@media screen and (min-width: 1220px) {
  .comparison-table-grid--license .comparison-table {
    grid-column: 3 / span 8;
  }
}

.comparison-table__blur {
  background-image: linear-gradient(0deg, #fafafa, #0000);
  bottom: 0;
  height: 7.5rem;
  left: 0;
  position: absolute;
  right: 0;
}

.comparison-table__blur-toggle {
  align-items: center;
  background: #f5f5f5;
  border: none;
  border-radius: 20px;
  display: flex;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5rem;
  margin: 2.5rem auto 0;
  padding: 0.5rem 0.75rem;
}

.comparison-table__blur-toggle .comparison-table__blur-toggle__cross,
.comparison-table__blur-toggle--is-expanded
  .comparison-table__blur-toggle__plus {
  display: none;
}

.comparison-table__blur-toggle--is-expanded
  .comparison-table__blur-toggle__cross {
  color: #212123;
  display: inline-block;
  height: 1.125rem;
  width: 1.125rem;
}

.comparison-table__blur-toggle .comparison-table__blur-toggle__cross,
.comparison-table__blur-toggle .comparison-table__blur-toggle__plus {
  margin-left: 0.75rem;
}

.comparison-table-wrapper {
  position: relative;
}

.pricing-plans {
  align-items: flex-end;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
}

/*@media screen and (min-width:768px) {*/
/*    .pricing-plans {*/
/*        gap: 1.5rem*/
/*    }*/
/*}*/

.pricing-plans__notes {
  margin-top: 1.5rem;
  text-align: center;
  width: 100%;
}

@media screen and (min-width: 768px) {
  .pricing-plans__notes {
    margin-top: 1rem;
  }
}

.pricing-plans__notes p {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.pricing-plans__notes p:first-child {
  margin-bottom: 0.5rem;
}

.pricing-plans__notes p:last-child {
  color: #0000007a;
}

.pricing-plan {
  position: relative;
  width: 100%;
}

@media screen and (min-width: 768px) {
  .pricing-plan {
    width: 20.5rem;
  }
}

@media screen and (min-width: 1024px) {
  .pricing-plan {
    width: 24.5rem;
  }
}

@media screen and (min-width: 1220px) {
  .pricing-plan {
    width: 25.5rem;
  }
}

.pricing-plan__box {
  box-shadow: 0 1px 2px #00000014, 0 4px 8px #00000005;
  height: 100%;
  padding: 2rem 1.25rem;
  position: relative;
}

@media screen and (min-width: 1220px) {
  .pricing-plan__box {
    padding: 2rem 1.5rem;
  }
}

.pricing-plan__tags {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

@media screen and (max-width: 1023px) {
  .pricing-plan__tags {
    flex-wrap: wrap;
  }
}

.pricing-plan__button {
  display: block;
  margin: 1.5rem auto 0.5rem;
  text-align: center;
  font-weight: 700;
}

@media screen and (min-width: 1024px) {
  .pricing-plan__button {
    width: calc(100% - 16px);
  }
}

.pricing-plan__name {
  font-size: 1.5rem;
  font-weight: 600;
  letter-spacing: -0.5px;
  line-height: 2rem;
}

.pricing-plan__price {
  display: block;
  font-size: 2.75rem;
  font-weight: 700;
  letter-spacing: -1px;
  line-height: 3rem;
  margin: 1rem 0 0.75rem;
}

.pricing-plan__banner {
  background: #0000000a;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.25rem;
  margin-bottom: 0.5rem;
  padding: 0.625rem;
  position: relative;
  text-align: center;
  width: 100%;
}

.pricing-plan__banner em {
  color: #f26725;
  font-weight: 600;
}

.pricing-plan__banner .annotation {
  position: absolute;
  right: 5.875rem;
  text-align: left;
  top: 1rem;
}

.pricing-plan__sticker {
  position: absolute;
  top: 0;
  z-index: -1;
}

@media screen and (max-width: 1023px) {
  .pricing-plan__sticker {
    max-width: 16rem;
  }
}

.pricing-plan__sticker--standard {
  left: -12.875rem;
  top: 2.9375rem;
}

@media screen and (min-width: 768px) {
  .pricing-plan__sticker--standard {
    left: -11.5rem;
  }
}

@media screen and (min-width: 1024px) {
  .pricing-plan__sticker--standard {
    left: -15.125rem;
  }
}

.pricing-plan__sticker--license {
  right: -10.8125rem;
  top: 0;
}

@media screen and (min-width: 768px) {
  .pricing-plan__sticker--license {
    right: -11.4375rem;
    top: 2.9375rem;
  }
}

@media screen and (min-width: 1024px) {
  .pricing-plan__sticker--license {
    right: -16.8125rem;
    top: 2.5rem;
  }
}

.pricing-plan__sticker--business {
  position: relative;
}

@media screen and (max-width: 1023px) {
  .pricing-plan__sticker--business {
    max-width: 13.0625rem;
  }
}

.pricing-plan__business__button {
  margin-top: 1.5rem;
  text-align: center;
  width: 100%;
}

@media screen and (min-width: 768px) {
  .pricing-plan__business__button {
    margin-top: 3.5rem;
  }
}

@media screen and (min-width: 1024px) {
  .pricing-plan__business__button {
    margin-bottom: 0;
    margin-top: 4rem;
  }
}

@media screen and (min-width: 1220px) {
  .pricing-plan__business__button {
    margin-top: 2.5rem;
  }
}

.pricing-plan__business__button--desktop {
  display: none;
}

@media screen and (min-width: 768px) {
  .pricing-plan__business__button--desktop {
    display: block;
  }

  .pricing-plan__business__button--mobile {
    display: none;
  }

  .pricing-plan__business__inner--left {
    min-width: 18rem;
  }
}

@media screen and (min-width: 1024px) {
  .pricing-plan__business__inner--left {
    min-width: 22.5rem;
  }
}

.pricing-plan__business__text {
  font-size: 1rem;
  line-height: 1.5rem;
}

.pricing-plan__business__text strong {
  font-weight: 600;
}

.pricing-plan__business__sticker-wrapper {
  left: -9rem;
  position: absolute;
  top: 34.375rem;
  z-index: -1;
}

@media screen and (min-width: 768px) {
  .pricing-plan__business__sticker-wrapper {
    left: -10rem;
    top: 18.5625rem;
  }
}

@media screen and (min-width: 1024px) {
  .pricing-plan__business__sticker-wrapper {
    left: -13.75rem;
    top: 13.75rem;
  }
}

@media screen and (min-width: 1220px) {
  .pricing-plan__business__sticker-wrapper {
    left: -15.6875rem;
    top: 12.25rem;
  }
}

@media screen and (max-width: 1023px) {
  .pricing-plan__business__sticker-wrapper {
    max-width: 13.0625rem;
  }
}

.pricing-plan__billing--big {
  line-height: 1.5rem;
}

.pricing-plan__billing--small {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.pricing-plan__billing--small strong {
  font-weight: 600;
}

.pricing-plan__divider-line {
  background-color: #00000014;
  display: block;
  height: 1px;
  margin: 0.75rem 0;
}

.pricing-plan__feature-group {
  margin-bottom: 1.5rem;
}

.pricing-plan__feature-group svg {
  margin-right: 0.5rem;
}

.pricing-plan__feature-group--excludes .pricing-plan__feature {
  color: #5c5c5c;
}

.pricing-plan__cta-subtitle {
  color: #000000a3;
  font-size: 0.875rem;
  line-height: 1.25rem;
  text-align: center;
}

.pricing-plan__features {
  margin-top: 2rem;
}

.pricing-plan__feature-title {
  font-weight: 600;
}

.pricing-plan__feature {
  align-items: flex-start;
  font-size: 0.9375rem;
  position: relative;
}

.pricing-plan__feature__checkmark {
  color: #fff;
}

.pricing-plan__feature__checkmark--smaller {
  color: #0000007a;
  height: 1.33125rem;
  width: 1.33125rem;
}

.pricing-plan__feature__checkmark--orange {
  color: #f26725;
}

.pricing-plan__feature__checkmark--purple {
  color: #b620e0;
}

.pricing-plan__feature svg {
  min-width: 1.5rem;
}

.pricing-plan__feature .tooltip__icon {
  color: #000;
}

.pricing-plan__feature .tooltip__icon #background {
  fill: #000;
  opacity: 0.096;
  transition: 0.25s cubic-bezier(0.455, 0.03, 0.515, 0.955);
}

.pricing-plan__feature--underlined {
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
  animation: dash 1.5s linear 2s forwards;
  color: #ccc;
  left: 2.125rem;
  position: absolute;
  top: 1.375rem;
}

@keyframes dash {
  to {
    stroke-dashoffset: 0;
  }
}

.pricing-plan__feature--with-tooltip {
  align-items: center;
}

.pricing-plan__feature--with-tooltip span {
  display: flex;
  margin-left: 0.5rem;
}

@media screen and (max-width: 1023px) {
  .pricing-plan__feature--permissions .tooltip.tooltip--new {
    display: none;
  }
}

.pricing-plan__feature__tooltip.tooltip.tooltip--new:before {
  background-color: #000c;
  max-width: 15rem;
  white-space: normal;
  width: max-content;
}

.pricing-plan__feature,
.pricing-plan__feature-title {
  display: flex;
  line-height: 1.5rem;
}

.pricing-plan__feature-title:not(:last-child),
.pricing-plan__feature:not(:last-child) {
  margin-bottom: 0.5rem;
}

@media screen and (min-width: 1024px) {
  .pricing-plan__inner-padding {
    padding: 0 1rem;
  }
}

.pricing-plan .skpabloo-selection-box {
  backdrop-filter: blur(32px);
}

.pricing-plan--standard .pricing-plan__button {
  background: #f26725;
}

@media screen and (min-width: 768px) {
  .pricing-plan--license {
    align-self: stretch;
    padding-top: 3rem;
  }

  .pricing-plan--license .pricing-plan__button {
    margin-top: 5.5rem;
  }
}

.pricing-plan--business {
  width: 100%;
}

@media screen and (min-width: 768px) {
  .pricing-plan--business {
    max-width: 42.5rem;
  }
}

@media screen and (min-width: 1024px) {
  .pricing-plan--business {
    max-width: 50.5625rem;
  }
}

@media screen and (min-width: 1220px) {
  .pricing-plan--business {
    max-width: 52.5rem;
  }
}

.pricing-plan--business .pricing-plan__box {
  display: flex;
  gap: 2rem;
}

@media screen and (max-width: 767px) {
  .pricing-plan--business .pricing-plan__box {
    flex-wrap: wrap;
  }
}

@media screen and (min-width: 768px) {
  .pricing-plan--business .pricing-plan__box {
    gap: 4rem;
    padding: 2rem 1.25rem;
  }
}

@media screen and (min-width: 1024px) {
  .pricing-plan--business .pricing-plan__box {
    gap: 4.5625rem;
    padding: 2.5rem 2.5rem 2.5rem 1.5rem;
  }
}

@media screen and (min-width: 1220px) {
  .pricing-plan--business .pricing-plan__box {
    gap: 5.5rem;
  }
}

.pricing-plan--business .pricing-plan__features {
  margin-bottom: 1.5rem;
  margin-top: 0.75rem;
}

.pricing-plan--business .pricing-plan__price {
  margin-bottom: 1rem;
}

.pricing-plan--business .pricing-plan__feature {
  font-size: 1rem;
}

.pricing-plan--business .skpabloo-selection-box--crosses {
  background-image: linear-gradient(90deg, #b620e0 50%, #0000 0),
    linear-gradient(90deg, #b620e0 50%, #0000 0),
    linear-gradient(180deg, #b620e0 50%, #0000 0),
    linear-gradient(180deg, #b620e0 50%, #0000 0);
  background-position: 0 0, 0 100%, 0 0, 100% 0;
  background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;
  background-size: 10px 1px, 10px 1px, 1px 10px, 1px 10px;
  border: none;
}

.pricing-plan--business
  .skpabloo-selection-box--crosses
  .skpabloo-selection-box__inner-box-top-left {
  left: -0.5px;
  top: -5px;
}

.pricing-plan--business
  .skpabloo-selection-box--crosses
  .skpabloo-selection-box__inner-box-top-right {
  right: -5px;
  top: -5px;
}

.pricing-plan--business
  .skpabloo-selection-box--crosses
  .skpabloo-selection-box__inner-box-bottom-left {
  bottom: -1px;
  left: 0;
}

.pricing-plan--business
  .skpabloo-selection-box--crosses
  .skpabloo-selection-box__inner-box-bottom-right {
  bottom: -1px;
  right: -5px;
}

.pricing-plan--business .skpabloo-selection-box__inner-box:after,
.pricing-plan--business .skpabloo-selection-box__inner-box:before {
  background: #b620e0;
}

.pricing-plan--business .pricing-plan__sticker {
  transform: rotate(-15deg);
}

::selection {
  background-color: #ffe8db;
}

.page-pricing {
  background-color: #fafafa;
}

.page-pricing #content {
  overflow: clip;
}

.hero {
  padding-top: 4rem;
  position: relative;
}

@media screen and (min-width: 768px) {
  .hero {
    padding-top: 6rem;
  }
}

.hero__title-wrapper {
  text-align: center;
}

@media screen and (max-width: 767px) {
  .hero__title-wrapper {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
}

@media screen and (max-width: 767px) and (min-width: 1024px) {
  .hero__title-wrapper {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}

.hero__title {
  font-size: 4.75rem;
  font-weight: 900;
  letter-spacing: -0.09375rem;
  line-height: 4.75rem;
  margin-bottom: 1.5rem;
}

@media screen and (max-width: 767px) {
  .hero__title {
    font-size: 2.75rem;
    letter-spacing: -0.0625rem;
    line-height: 3rem;
  }
}

@media screen and (min-width: 768px) and (max-width: 1219px) {
  .hero__title {
    font-size: 3.5rem;
    line-height: 3.5rem;
  }
}

.hero__lead {
  text-wrap: balance;
  font-size: 1.0625rem;
  font-weight: 300;
  line-height: 1.5rem;
  margin: 0 auto 2.75rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

@media screen and (min-width: 1024px) {
  .hero__lead {
    font-size: 1.25rem;
    line-height: 1.75rem;
    padding-left: 2rem;
    padding-right: 2rem;
  }
}

@media screen and (min-width: 768px) {
  .hero__lead {
    max-width: 32.5rem;
    padding: 0;
  }
}

@media screen and (min-width: 1024px) {
  .hero__lead {
    text-wrap: initial;
    margin-bottom: 2.25rem;
    max-width: 40.1875rem;
  }
}

@media screen and (min-width: 1220px) {
  .hero__lead {
    margin-bottom: 2.75rem;
    max-width: 52.5rem;
  }
}

.hero__lead strong {
  font-weight: 600;
}

@media screen and (min-width: 768px) {
  .hero__lead strong {
    font-weight: 500;
  }
}

.faq-section {
  margin-bottom: 4rem;
}

@media screen and (min-width: 768px) {
  .faq-section {
    margin-bottom: 6rem;
  }
}

.faq-section .wrapper {
  border-bottom: 1px solid #00000014;
  padding-bottom: 4rem;
}

@media screen and (min-width: 768px) {
  .faq-section .wrapper {
    padding-bottom: 6rem;
  }
}

.faq-section__wrapper {
  padding-top: 0;
}

@media screen and (min-width: 768px) {
  .faq-section__content {
    margin-top: 1.25rem;
  }
}

.faq__item.is-active .faq__item__question,
.faq__item__question:hover {
  color: #f26725;
}

@media screen and (max-width: 767px) {
  .faq-section__header__heading {
    font-size: 1.75rem;
    letter-spacing: -0.5px;
    line-height: 2rem;
    margin-bottom: 2.5rem;
  }
}

.pricing-plans-section {
  margin-bottom: 4rem;
}

@media screen and (min-width: 1220px) {
  .pricing-plans-section {
    margin-bottom: 3rem;
  }

  .comparison-table-section > .wrapper .comparison-table {
    border-top: 1px solid #00000014;
    padding: 4rem 0 0;
  }
}

.comparison-table-section .top-bar {
  backdrop-filter: blur(40px);
  background: #fafafa;
  border-bottom: 1px solid #00000014;
  padding: 0;
}

.sticker-links-section {
  margin-bottom: 4rem;
  margin-top: 4rem;
}

@media screen and (min-width: 1024px) {
  .sticker-links-section {
    margin-bottom: 4rem;
    margin-top: 6rem;
  }
}

.sticker-links-section .sticker-links-section__wrapper {
  padding-bottom: 4rem;
  position: relative;
}

.sticker-links-section .sticker-links-section__wrapper:after {
  border-bottom: 1px solid #00000014;
  bottom: 0;
  content: "";
  left: 0;
  position: absolute;
  right: 0;
}

.sticker-links-section .sticker-link:first-child a {
  display: block;
}

.footnote-section .wrapper {
  border-bottom: 1px solid #00000014;
  padding-bottom: 1.5rem;
}

.pricing__footnote {
  color: #0000007a;
  font-size: 0.875rem;
  line-height: 1.25rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles/pricing-skpabloocss/icons.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EAErB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,kBAAkB;IAClB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;;EAGE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,aAAa;AACf;;AAEA;;;EAGE,SAAS;EACT,kBAAkB;AACpB;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;;;EAGE,mBAAmB;EAEnB,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,aAAa;EACb,OAAO;EACP,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,WAAW;AACb;;AAEA;;;;;;EAME,sBAAsB;EACtB,wBAAwB;EACxB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR;yDACuD;EACvD,cAAc;AAChB;;AAEA;EACE;;;;;;IAME,wBAAwB;EAC1B;AACF;;AAEA;EACE;;;;;;IAME,eAAe;EACjB;AACF;;AAEA;;;EAGE,wBAAwB;AAC1B;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,yDAAyD;EACzD,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;EACtB;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,aAAa;IACb,oEAAoE;IACpE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,iDAAiD;EACnD;AACF;;AAEA;EACE;IACE,6GAA6G;IAC7G,sCAAsC;EACxC;AACF;;AAEA;EACE;IACE,kGAAkG;IAClG,sCAAsC;EACxC;AACF;;AAEA;EACE;IACE,aAAa;IACb,iBAAiB;IAEjB,mBAAmB;IACnB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IAEE,mBAAmB;IACnB,kBAAkB;IAElB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE;IACE,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,uEAAuE;EACvE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE;IACE,gBAAgB;IAChB,oBAAoB;EACtB;AACF;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,qBAAqB;EACrB,yBAAyB;EACzB,4BAA4B;EAC5B,sBAAsB;EACtB;gDAC8C;EAC9C,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE;IACE,cAAc;IACd,WAAW;EACb;AACF;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE;IACE,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;IAClB,eAAe;IACf,cAAc;EAChB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,WAAW;EACb;AACF;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,eAAe;IACf,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;AACF;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,oBAAoB;EACtB;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,mBAAmB;IACnB,gBAAgB;EAClB;AACF;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR,MAAM;AACR;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,uDAAuD;EACvD,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,cAAc;EACd,cAAc;EACd;gDAC8C;EAC9C,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;EACpB;AACF;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;IAClB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE;;;;;;GAMC;EACD,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,6BAA6B;EAC7B,2BAA2B;EAC3B,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,SAAS;EACT,OAAO;EACP,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,yBAAyB;EACzB,yBAAyB;EACzB,SAAS;EACT,WAAW;EACX,cAAc;EACd,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kDAAkD;AACpD;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,sBAAsB;EACtB,6BAA6B;EAC7B,2BAA2B;EAC3B,WAAW;EACX,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE;IACE,SAAS;IACT,4BAA4B;EAC9B;AACF;;AAEA;;EAEE,sBAAsB;EACtB,6BAA6B;EAC7B,2BAA2B;EAC3B,WAAW;EACX,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,cAAc;IACd,UAAU;EACZ;AACF;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,wEAAwE;EACxE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,iBAAiB;AACnB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yDAAwT;EACxT,wCAAwC;EACxC,4BAA4B;EAC5B,qBAAqB;EACrB,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gDAAgD;AAClD;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,iDAAiD;EACnD;AACF;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,cAAc;EACd,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;EAClB;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,MAAM;EACN,6DAA6D;EAC7D,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;;;EAGE;IAEE,2BAA2B;IAC3B,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,yDAAyD;AAC3D;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,gCAAgC;IAChC,sBAAsB;IACtB,YAAY;EACd;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;;;EAGE,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,kCAAkC;EAClC,SAAS;EACT,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;;;;IAIE,mBAAmB;EACrB;AACF;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,qBAAqB;IACrB,uBAAuB;EACzB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,kBAAkB;IAClB,aAAa;IACb,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,iDAAiD;EACnD;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,mEAAmE;AACrE;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,uDAAuD;EACvD,SAAS;EACT,cAAc;EACd,OAAO;EACP,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;EAEE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;AACzB;;AAEA,wCAAwC;AACxC,uBAAuB;AACvB,sBAAsB;AACtB,QAAQ;AACR,IAAI;;AAEJ;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,oDAAoD;EACpD,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE;IACE,kBAAkB;IAClB,cAAc;EAChB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,WAAW;EACb;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;;AAEA;EACE;IACE,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,aAAa;EACf;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,aAAa;EACf;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,cAAc;EACd,yDAAyD;AAC3D;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,uCAAuC;EACvC,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EAEE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,SAAS;IACT,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,cAAc;IACd,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;;;iDAG+C;EAC/C,6CAA6C;EAC7C,yDAAyD;EACzD,uDAAuD;EACvD,YAAY;AACd;;AAEA;;;EAGE,YAAY;EACZ,SAAS;AACX;;AAEA;;;EAGE,WAAW;EACX,SAAS;AACX;;AAEA;;;EAGE,YAAY;EACZ,OAAO;AACT;;AAEA;;;EAGE,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE;IACE,kBAAkB;IAClB,0BAA0B;IAC1B,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE;IACE,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,sBAAsB;IACtB,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE;IACE,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,qBAAqB;EACvB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,+BAA+B;IAC/B,iBAAiB;EACnB;AACF;;AAEA;EAEE,2BAA2B;EAC3B,mBAAmB;EACnB,kCAAkC;EAClC,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,mBAAmB;IACnB,gBAAgB;EAClB;AACF;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,SAAS;EACT,WAAW;EACX,OAAO;EACP,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB","sourcesContent":[".flex {\n  display: flex;\n}\n\n.inline-flex {\n  display: inline-flex;\n}\n\n.flex-row {\n  flex-direction: row;\n}\n\n.flex-col {\n  flex-direction: column;\n}\n\n.items-start {\n  align-items: flex-start;\n}\n\n.items-end {\n  align-items: flex-end;\n}\n\n.items-center {\n  align-items: center;\n}\n\n.items-baseline {\n  align-items: baseline;\n}\n\n.items-stretch {\n  align-items: stretch;\n}\n\n.justify-between {\n  justify-content: space-between;\n}\n\n.justify-around {\n  justify-content: space-around;\n}\n\n.justify-center {\n  justify-content: center;\n}\n\n.justify-start {\n  justify-content: flex-start;\n}\n\n.justify-end {\n  justify-content: flex-end;\n}\n\n.flex-1 {\n  flex: 1 1 0;\n}\n\n.flex-auto {\n  flex: 1 1 auto;\n}\n\n.flex-none {\n  flex: none;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.text-left {\n  text-align: left;\n}\n\n.text-responsive {\n  text-align: left;\n  margin-top: 15px;\n}\n\n@media screen and (max-width: 776px) {\n  .text-responsive {\n    text-align: center;\n    margin-top: 30px;\n  }\n}\n\n.uppercase {\n  text-transform: uppercase;\n}\n\n.hyphenate {\n  word-wrap: break-word;\n  -webkit-hyphens: auto;\n  hyphens: auto;\n  overflow-wrap: break-word;\n}\n\n.no-wrap {\n  white-space: nowrap;\n}\n\n.max-w-col-10,\n.max-w-col-4,\n.max-w-col-6,\n.max-w-col-8 {\n  width: 100%;\n}\n\n.max-w-col-4 {\n  max-width: 24rem;\n}\n\n.max-w-col-6 {\n  max-width: 36.75rem;\n}\n\n.max-w-col-8 {\n  max-width: 49.5rem;\n}\n\n.max-w-col-10 {\n  max-width: 62.25rem;\n}\n\n.faq__heading {\n  color: #0000008c;\n  font-size: 0.875rem;\n  font-weight: 600;\n  line-height: 1rem;\n  margin-bottom: 0;\n  text-transform: uppercase;\n}\n\n.faq__items + .faq__heading {\n  margin-top: 2.5rem;\n}\n\n.faq__item:not(:last-child) {\n  border-bottom: 1px solid #00000014;\n}\n\n.faq__item__question {\n  transition: color 0.25s cubic-bezier(0.19, 1, 0.22, 1);\n}\n\n@media percy, screen and (prefers-reduced-motion: reduce) {\n  .faq__item__question {\n    transition-duration: 1ms;\n  }\n}\n\n.faq__item__question-inner {\n  align-items: flex-start;\n  display: flex;\n  justify-content: space-between;\n  padding-bottom: 1.25rem;\n  padding-top: 1.25rem;\n  position: relative;\n  width: 100%;\n}\n\n.faq__item__question-text {\n  font-size: 1.0625rem;\n  font-weight: 500;\n  line-height: 1.5rem;\n}\n\n@media screen and (min-width: 1024px) {\n  .faq__item__question-text {\n    font-size: 1.25rem;\n    line-height: 1.75rem;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .faq__item__question-text {\n    font-size: 1.0625rem;\n    line-height: 1.5rem;\n  }\n}\n\n.faq__item__question__toggle {\n  display: none;\n}\n\n.faq__item__answer {\n  padding-bottom: 3rem;\n}\n\n.faq__item__answer h2,\n.faq__item__answer h3,\n.faq__item__answer h4 {\n  font-size: 1.0625rem;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 1.5rem;\n  margin-bottom: 1rem;\n  margin-top: 0;\n}\n\n.faq__item__question__icon {\n  -webkit-appearance: none;\n  appearance: none;\n  background-color: initial;\n  border: 0;\n  border-radius: 0;\n  height: 1.5rem;\n  line-height: normal;\n  margin: 0;\n  padding: 0;\n  position: relative;\n  right: 0.5rem;\n  width: 1.5rem;\n}\n\n.faq__item.is-active .faq__item__question,\n.faq__item.is-inactive .faq__item__question,\n.faq__item[data-toggleable] .faq__item__question {\n  margin: 0;\n  position: relative;\n}\n\n.faq__item.is-active .faq__item__question-text,\n.faq__item.is-inactive .faq__item__question-text,\n.faq__item[data-toggleable] .faq__item__question-text {\n  padding-right: 2.5rem;\n}\n\n.faq__item.is-active .faq__item__question__toggle,\n.faq__item.is-inactive .faq__item__question__toggle,\n.faq__item[data-toggleable] .faq__item__question__toggle {\n  align-items: center;\n  -webkit-appearance: none;\n  appearance: none;\n  background-color: initial;\n  border: 0;\n  border-radius: 0;\n  bottom: 0;\n  cursor: pointer;\n  display: flex;\n  left: 0;\n  line-height: normal;\n  margin: 0;\n  padding: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 100%;\n}\n\n.faq__item.is-active .faq__item__question__icon:after,\n.faq__item.is-active .faq__item__question__icon:before,\n.faq__item.is-inactive .faq__item__question__icon:after,\n.faq__item.is-inactive .faq__item__question__icon:before,\n.faq__item[data-toggleable] .faq__item__question__icon:after,\n.faq__item[data-toggleable] .faq__item__question__icon:before {\n  background-color: #000;\n  border-radius: 0.0625rem;\n  content: \"\";\n  height: 0.125rem;\n  position: absolute;\n  right: 0;\n  transition: transform 0.4s cubic-bezier(0.19, 1, 0.22, 1),\n    background-color 0.25s cubic-bezier(0.19, 1, 0.22, 1);\n  width: 0.75rem;\n}\n\n@media percy, screen and (prefers-reduced-motion: reduce) {\n  .faq__item.is-active .faq__item__question__icon:after,\n  .faq__item.is-active .faq__item__question__icon:before,\n  .faq__item.is-inactive .faq__item__question__icon:after,\n  .faq__item.is-inactive .faq__item__question__icon:before,\n  .faq__item[data-toggleable] .faq__item__question__icon:after,\n  .faq__item[data-toggleable] .faq__item__question__icon:before {\n    transition-duration: 1ms;\n  }\n}\n\n@media screen and (min-width: 768px) {\n  .faq__item.is-active .faq__item__question__icon:after,\n  .faq__item.is-active .faq__item__question__icon:before,\n  .faq__item.is-inactive .faq__item__question__icon:after,\n  .faq__item.is-inactive .faq__item__question__icon:before,\n  .faq__item[data-toggleable] .faq__item__question__icon:after,\n  .faq__item[data-toggleable] .faq__item__question__icon:before {\n    width: 0.875rem;\n  }\n}\n\n.faq__item.is-active .faq__item__question__icon:after,\n.faq__item.is-inactive .faq__item__question__icon:after,\n.faq__item[data-toggleable] .faq__item__question__icon:after {\n  transform: rotate(90deg);\n}\n\n.faq__item.is-active .faq__item__answer,\n.faq__item.is-inactive .faq__item__answer,\n.faq__item[data-toggleable] .faq__item__answer {\n  display: none;\n}\n\n.faq__item.is-active .faq__item__answer {\n  animation: fadeInDown 0.6s cubic-bezier(0.19, 1, 0.22, 1);\n  display: block;\n}\n\n@media percy, screen and (prefers-reduced-motion: reduce) {\n  .faq__item.is-active .faq__item__answer {\n    animation: none;\n  }\n}\n\n.faq__item.is-active .faq__item__question__icon:after,\n.faq__item.is-active .faq__item__question__icon:before {\n  transform: rotate(180deg);\n}\n\n.faq__section__icon {\n  margin-bottom: 1rem;\n}\n\n@media screen and (max-width: 767px) {\n  .faq__section__icon {\n    display: none;\n  }\n}\n\n.faq__section__heading {\n  font-size: 2rem;\n  font-weight: 900;\n  line-height: 2.25rem;\n  margin-bottom: 2.5rem;\n}\n\n@media screen and (min-width: 768px) {\n  .faq__section__heading {\n    font-size: 2.5rem;\n    line-height: 3rem;\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .faq__section__heading {\n    font-size: 3.5rem;\n    line-height: 3.75rem;\n  }\n}\n\n.faq__section__support-link {\n  font-size: 1.5rem;\n  font-weight: 500;\n  font-weight: 700;\n  line-height: 2rem;\n  margin-top: 3rem;\n}\n\n@media screen and (max-width: 767px) {\n  .faq__section__support-link {\n    font-size: 1.25rem;\n    font-weight: 700;\n    line-height: 1.75rem;\n  }\n}\n\n.faq-section__wrapper {\n  padding-top: 3rem;\n  position: relative;\n}\n\n@media screen and (max-width: 767px) {\n  .faq-section__wrapper {\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n  }\n}\n\n@media screen and (min-width: 768px) {\n  .faq-section__wrapper {\n    column-gap: 1.5rem;\n    display: grid;\n    grid-template-areas: \"header header content content content content\";\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n}\n\n@media screen and (min-width: 768px) and (min-width: 768px) {\n  .faq-section__wrapper {\n    grid-template-columns: repeat(6, minmax(0, 1fr));\n  }\n}\n\n@media screen and (min-width: 768px) and (min-width: 1024px) {\n  .faq-section__wrapper {\n    grid-template-columns: repeat(12, minmax(0, 1fr));\n  }\n}\n\n@media screen and (min-width: 1024px) and (max-width: 1219px) {\n  .faq-section__wrapper {\n    grid-template-areas: \"header header header . content content content content content content content content\";\n    grid-template-columns: repeat(12, 1fr);\n  }\n}\n\n@media screen and (min-width: 1220px) {\n  .faq-section__wrapper {\n    grid-template-areas: \". header header . . content content content content content content content\";\n    grid-template-columns: repeat(12, 1fr);\n  }\n}\n\n@media screen and (min-width: 768px) {\n  .faq-section__header {\n    display: flex;\n    grid-area: header;\n    height: -moz-fit-content;\n    height: fit-content;\n    position: sticky;\n  }\n}\n\n@media screen and (min-width: 1024px) and (max-width: 1219px) {\n  .faq-section__header {\n    margin-left: 2rem;\n  }\n}\n\n@media screen and (min-width: 768px) {\n  .faq-section__header--has-border {\n    height: -moz-fit-content;\n    height: fit-content;\n    position: relative;\n    width: -moz-fit-content;\n    width: fit-content;\n  }\n}\n\n@media screen and (min-width: 768px) and (min-width: 768px) and (max-width: 1023px) {\n  .faq-section__header--has-border {\n    padding-left: 0.375rem;\n  }\n}\n\n@media screen and (min-width: 768px) {\n  .faq-section__header--has-border .faq-section__header__heading {\n    line-height: 2.5rem;\n    margin-bottom: 0;\n    padding-left: 0.375rem;\n    padding-right: 0.625rem;\n    width: min-content;\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .faq-section__header--sticky {\n    position: sticky;\n    top: 1.25rem;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .faq-section__header--has-border .skpabloo-selection-box {\n    display: none;\n  }\n}\n\n.faq-section__header__heading {\n  font-size: 2rem;\n  font-weight: 700;\n  letter-spacing: -0.03125rem;\n  line-height: 2.25rem;\n  margin-top: 0;\n}\n\n@media screen and (max-width: 767px) {\n  .faq-section__header__heading {\n    font-size: 1.75rem;\n    line-height: 2rem;\n  }\n}\n\n.faq-section__header__blurb {\n  font-size: 1.0625rem;\n  font-weight: 300;\n  line-height: 1.5rem;\n  margin-top: 1rem;\n}\n\n@media screen and (max-width: 767px) {\n  .faq-section__header__blurb {\n    margin-bottom: 2.5rem;\n  }\n}\n\n.faq-section__content {\n  grid-area: content;\n}\n\n@media screen and (min-width: 768px) {\n  .faq-section__content {\n    padding-right: 2rem;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .faq-section__item__answer {\n    font-size: 1rem;\n    font-weight: 300;\n    line-height: 1.5rem;\n  }\n}\n\n.faq-section__support {\n  font-size: 1.25rem;\n  font-weight: 700;\n  font-weight: 500;\n  line-height: 1.5rem;\n  margin-top: 3rem;\n}\n\n.faq-section__support__action {\n  margin-top: 1rem;\n}\n\n.faq-section__support__action:after {\n  vertical-align: text-bottom;\n}\n\n.education-banner {\n  background-color: #fff;\n  border-radius: 6px;\n  box-shadow: 0 1px 2px #00000014, 0 4px 8px #00000005, 0 0 4px #00000014;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  overflow: hidden;\n  padding: 2.5rem 1.25rem;\n  position: relative;\n}\n\n@media screen and (min-width: 768px) {\n  .education-banner {\n    padding: 2rem;\n  }\n}\n\n.education-banner__text {\n  z-index: 10;\n}\n\n@media screen and (max-width: 767px) {\n  .education-banner__text {\n    width: 100%;\n  }\n}\n\n.education-banner__title {\n  font-size: 2rem;\n  font-weight: 700;\n  letter-spacing: -0.5px;\n  line-height: 2.5rem;\n  text-align: center;\n  text-transform: capitalize;\n}\n\n@media screen and (min-width: 768px) {\n  .education-banner__title {\n    text-align: left;\n    text-transform: none;\n  }\n}\n\n.education-banner__title .highlight {\n  -webkit-text-fill-color: #0000;\n  -webkit-background-clip: text;\n  background-clip: text;\n  background-color: #ffb387;\n  background-repeat: no-repeat;\n  background-size: cover;\n  font-family: Caveat, Marfa, system-ui, -apple-system, BlinkMacSystemFont,\n    Helvetica Neue, Helvetica, Arial, sans-serif;\n  font-size: 2.5rem;\n  letter-spacing: -0.03125rem;\n  line-height: 2.5rem;\n}\n\n@media screen and (max-width: 767px) {\n  .education-banner__title .highlight {\n    display: block;\n    width: 100%;\n  }\n}\n\n.education-banner__blurb {\n  font-size: 1.0625rem;\n  font-weight: 300;\n  line-height: 1.5rem;\n  margin-bottom: 1.5rem;\n  margin-top: 1rem;\n  text-align: center;\n  width: 100%;\n}\n\n@media screen and (min-width: 768px) {\n  .education-banner__blurb {\n    margin-bottom: 0;\n    margin-top: 0.5rem;\n    text-align: left;\n  }\n}\n\n.education-banner__cta {\n  align-self: center;\n}\n\n@media screen and (max-width: 767px) {\n  .education-banner__cta {\n    margin: 0 auto;\n  }\n}\n\n.education-banner__image {\n  position: absolute;\n}\n\n@media screen and (min-width: 768px) {\n  .education-banner__image {\n    bottom: -1.5625rem;\n    right: 7.375rem;\n    width: 14.5rem;\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .education-banner__image {\n    bottom: -1.5625rem;\n    right: 7.375rem;\n  }\n}\n\n@media screen and (min-width: 1220px) {\n  .education-banner__image {\n    bottom: -1.4375rem;\n    right: 7rem;\n  }\n}\n\n.tabs {\n  background-color: #ebebeb;\n  border-radius: 12px;\n  display: inline-flex;\n  padding: 0.125rem;\n}\n\n.tabs__button {\n  -webkit-appearance: none;\n  appearance: none;\n  background-color: initial;\n  border: 0;\n  border-radius: 0;\n  border-radius: 0.625rem;\n  color: #000000a3;\n  display: block;\n  font-size: 1rem;\n  font-weight: 500;\n  line-height: normal;\n  line-height: 1.5rem;\n  margin: 0;\n  padding: 0.375rem 1rem;\n}\n\n.tabs__button:hover {\n  color: #212123;\n}\n\n.tabs__button:not(:last-child) {\n  margin-right: 0.125rem;\n}\n\n.tabs__button--active {\n  background-color: #fff;\n  box-shadow: 0 1px 1px #00000014;\n  color: #212123;\n}\n\n.callout-simple {\n  background-color: #f5f5f5;\n  border-radius: 6px;\n  display: flex;\n  flex-direction: column;\n  padding: 1.25rem 1.25rem 2rem;\n}\n\n@media screen and (min-width: 768px) {\n  .callout-simple {\n    flex-direction: row;\n  }\n}\n\n@media screen and (min-width: 768px) and (max-width: 1023px) {\n  .callout-simple {\n    flex-wrap: wrap;\n    justify-content: flex-start;\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .callout-simple {\n    justify-content: center;\n    padding: 1.25rem 1.5625rem;\n  }\n}\n\n.callout-simple__icon {\n  margin-bottom: 0.5rem;\n  vertical-align: initial;\n}\n\n@media screen and (min-width: 768px) and (max-width: 1023px) {\n  .callout-simple__icon {\n    width: 100%;\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .callout-simple__icon {\n    margin-bottom: 0;\n    margin-right: 0.5rem;\n  }\n}\n\n.callout-simple__text {\n  color: #212123;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5rem;\n}\n\n@media screen and (min-width: 768px) and (max-width: 1023px) {\n  .callout-simple__text {\n    max-width: 40rem;\n  }\n}\n\n.get-started-sticker {\n  margin-bottom: 4rem;\n  margin-top: 4rem;\n}\n\n@media screen and (min-width: 1024px) {\n  .get-started-sticker {\n    margin-bottom: 6rem;\n    margin-top: 6rem;\n  }\n}\n\n.get-started-sticker--no-margins {\n  margin-bottom: 0;\n  margin-top: 0;\n}\n\n.get-started-sticker--with-divider .wrapper {\n  padding-top: 4rem;\n  position: relative;\n}\n\n.get-started-sticker--with-divider .wrapper:before {\n  border-top: 1px solid #00000014;\n  content: \"\";\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n@media screen and (min-width: 1024px) {\n  .get-started-sticker--with-divider .wrapper {\n    padding-top: 6rem;\n  }\n}\n\n.get-started-sticker__sticker {\n  -webkit-backface-visibility: hidden;\n  -moz-backface-visibility: hidden;\n  display: block;\n  height: 7.75rem;\n  margin: 0 auto 1.5rem;\n  -webkit-mask-image: -webkit-radial-gradient(#fff, #000);\n  width: 7.75rem;\n}\n\n.get-started-sticker__heading {\n  font-size: 1.75rem;\n  font-weight: 700;\n  letter-spacing: -0.5px;\n  line-height: 2.75rem;\n  margin: 0 auto 2rem;\n  max-width: 20.5rem;\n  text-align: center;\n}\n\n@media screen and (min-width: 768px) {\n  .get-started-sticker__heading {\n    font-size: 2.75rem;\n    letter-spacing: -1px;\n    line-height: 3.5rem;\n    margin-bottom: 2.25rem;\n    max-width: 32.5rem;\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .get-started-sticker__heading {\n    max-width: 36.75rem;\n  }\n}\n\n.get-started-sticker__heading em {\n  color: #f26725;\n  display: block;\n  font-family: Caveat, Marfa, system-ui, -apple-system, BlinkMacSystemFont,\n    Helvetica Neue, Helvetica, Arial, sans-serif;\n  font-size: 2.75rem;\n  font-weight: 700;\n  line-height: 2rem;\n}\n\n@media screen and (min-width: 768px) {\n  .get-started-sticker__heading em {\n    font-size: 3.5rem;\n    letter-spacing: -1px;\n    margin-top: 0.5rem;\n  }\n}\n\n.get-started-sticker__blurb {\n  font-size: 1.0625rem;\n  font-weight: 300;\n  line-height: 1.5rem;\n  margin: 0 auto 1.5rem;\n  max-width: 18rem;\n  text-align: center;\n}\n\n@media screen and (min-width: 1024px) {\n  .get-started-sticker__blurb {\n    font-size: 1.25rem;\n    line-height: 1.75rem;\n  }\n}\n\n@media screen and (min-width: 768px) {\n  .get-started-sticker__blurb {\n    max-width: 29.5rem;\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .get-started-sticker__blurb {\n    margin: 0 auto 1.5rem;\n    max-width: 32.5rem;\n    max-width: 36.75rem;\n  }\n}\n\n.get-started-sticker__actions {\n  text-align: center;\n}\n\n.artboard.pitch .artboard__body {\n  padding: 2rem 1.25rem;\n}\n\n@media screen and (min-width: 768px) {\n  .artboard.pitch .artboard__body {\n    padding: 3.5rem;\n  }\n}\n\n.pill {\n  background-color: #00000014;\n  border-radius: 6px;\n  color: #000000b3;\n  display: inline-block;\n  font-size: 0.6875rem;\n  font-weight: 600;\n  line-height: 0;\n  padding: 0.75rem 0.5rem;\n  text-transform: uppercase;\n}\n\n.pill.pill--yellow {\n  background-color: #f5a925;\n  color: #000c;\n}\n\n.pill.pill--feature {\n  margin-left: 0.25rem;\n  position: relative;\n  top: -0.1875rem;\n}\n\n.pill.pill--orange {\n  background-color: #f26725;\n  color: #fff;\n}\n\n.pill--secondary {\n  background-color: #ebebeb;\n  color: #000000a3;\n}\n\n.pill--rainbow {\n  background: linear-gradient(\n    90deg,\n    #e8b8fc,\n    #e7db8f 35%,\n    #a6f1e8 69%,\n    #88fccf\n  );\n  color: #212123;\n  text-transform: uppercase;\n}\n\n.pill--round {\n  background-color: #00000014;\n  border-radius: 6px;\n  border-radius: 9999px;\n  color: #000000b3;\n  font-size: 0.6875rem;\n  font-weight: 600;\n  line-height: 0;\n  min-width: 1.25rem;\n  padding: 0.625rem 0.375rem;\n  text-transform: uppercase;\n}\n\n.pill--round,\n.pill-link {\n  display: inline-block;\n}\n\n.pill-link:hover .pill {\n  color: #212123;\n}\n\n.skpabloo-selection-box {\n  border: 1px solid #f26725;\n  bottom: -0.1875rem;\n  left: -0.1875rem;\n  position: absolute;\n  right: -0.1875rem;\n  top: -0.1875rem;\n  z-index: -1;\n}\n\n.skpabloo-selection-box__inner-box {\n  background-clip: padding-box;\n  background-color: #fff;\n  border: 0.5px solid #00000040;\n  box-shadow: 0 1px 2px #0003;\n  height: 6px;\n  position: absolute;\n  width: 6px;\n}\n\n.skpabloo-selection-box__inner-box-top-left {\n  left: -4px;\n  top: -4px;\n}\n\n.skpabloo-selection-box__inner-box-top-right {\n  right: -4px;\n  top: -4px;\n}\n\n.skpabloo-selection-box__inner-box-bottom-left {\n  bottom: -4px;\n  left: -4px;\n}\n\n.skpabloo-selection-box__inner-box-bottom-right {\n  bottom: -4px;\n  right: -4px;\n}\n\n.skpabloo-selection-box--crosses {\n  border: 0.5px solid #f26725;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  top: 0;\n}\n\n.skpabloo-selection-box--crosses .skpabloo-selection-box__inner-box {\n  background: none;\n  border: none;\n  box-shadow: none;\n}\n\n.skpabloo-selection-box--crosses .skpabloo-selection-box__inner-box:after,\n.skpabloo-selection-box--crosses .skpabloo-selection-box__inner-box:before {\n  background: #f26725;\n  content: \"\";\n  display: block;\n  height: 8px;\n  position: absolute;\n  width: 0.5px;\n}\n\n.skpabloo-selection-box--crosses .skpabloo-selection-box__inner-box:before {\n  transform: rotate(45deg);\n}\n\n.skpabloo-selection-box--crosses .skpabloo-selection-box__inner-box:after {\n  transform: rotate(135deg);\n}\n\n.skpabloo-selection-box--crosses .skpabloo-selection-box__inner-box-top-left {\n  left: -1px;\n  top: -4.5px;\n}\n\n.skpabloo-selection-box--crosses .skpabloo-selection-box__inner-box-top-right {\n  right: -6px;\n  top: -4.5px;\n}\n\n.skpabloo-selection-box--crosses .skpabloo-selection-box__inner-box-bottom-left {\n  bottom: -2px;\n  left: -0.5px;\n}\n\n.skpabloo-selection-box--crosses .skpabloo-selection-box__inner-box-bottom-right {\n  bottom: -2px;\n  right: -6px;\n}\n\n.artboard {\n  align-items: flex-start;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  will-change: transform;\n}\n\n@media screen and (min-width: 1024px) {\n  .artboard--fixed {\n    position: absolute;\n  }\n}\n\n.artboard--symbol .artboard__name {\n  color: #b620e0;\n}\n\n.artboard__name {\n  align-items: center;\n  color: #858585;\n  cursor: default;\n  display: flex;\n  font-size: 0.75rem;\n  gap: 0.25rem;\n  letter-spacing: -0.4px;\n  line-height: 1rem;\n  margin-bottom: 0.25rem;\n  margin-left: 0.25rem;\n}\n\n.artboard:not(.artboard--selected) .artboard__name:hover + .artboard__body {\n  position: relative;\n}\n\n.artboard:not(.artboard--selected)\n  .artboard__name:hover\n  + .artboard__body:before {\n  background-color: initial;\n  border: 2px solid #f26725;\n  bottom: 0;\n  content: \"\";\n  display: block;\n  height: 100%;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 100%;\n}\n\n.artboard__body {\n  background-color: #fff;\n  box-shadow: 0 0 2px #0000001a, 0 2px 4px #0000001a;\n}\n\n.artboard--selected,\n.artboard__body {\n  position: relative;\n}\n\n.artboard--selected .artboard__body {\n  border: 0.5px solid #f26725;\n}\n\n.artboard--selected .artboard__body:after,\n.artboard--selected .artboard__body:before {\n  background-color: #fff;\n  border: 0.5px solid #00000040;\n  box-shadow: 0 1px 2px #0003;\n  content: \"\";\n  display: block;\n  height: 0.5rem;\n  position: absolute;\n  width: 0.5rem;\n}\n\n.artboard--selected .artboard__body:before {\n  left: -0.25rem;\n  top: -0.25rem;\n}\n\n.artboard--selected .artboard__body:after {\n  right: -0.25rem;\n  top: -0.25rem;\n}\n\n@media screen and (min-width: 1024px) {\n  .artboard--selected .artboard__body {\n    border: 0;\n    outline: 0.5px solid #f26725;\n  }\n}\n\n.artboard--selected:after,\n.artboard--selected:before {\n  background-color: #fff;\n  border: 0.5px solid #00000040;\n  box-shadow: 0 1px 2px #0003;\n  content: \"\";\n  display: block;\n  height: 0.5rem;\n  position: absolute;\n  width: 0.5rem;\n  z-index: 10;\n}\n\n.artboard--selected:before {\n  bottom: -0.25rem;\n  left: -0.25rem;\n}\n\n.artboard--selected:after {\n  bottom: -0.25rem;\n  right: -0.25rem;\n}\n\n.artboard--moving .artboard__body:after,\n.artboard--moving .artboard__body:before,\n.artboard--moving:after,\n.artboard--moving:before {\n  display: none;\n}\n\n.artboard__asset {\n  display: block;\n}\n\n@media screen and (max-width: 1023px) {\n  .artboard__asset {\n    max-width: 100%;\n  }\n}\n\n.artboard--full-width .artboard__body {\n  width: 100%;\n}\n\n.annotation {\n  display: none;\n}\n\n@media screen and (min-width: 1024px) {\n  .annotation {\n    display: block;\n    z-index: 1;\n  }\n}\n\n.annotation kbd {\n  align-items: center;\n  background-color: #fff;\n  border: 1px solid #ebebeb;\n  border-radius: 8px;\n  box-shadow: 0 1px 0 0 #ccc;\n  color: #212123;\n  display: inline-flex;\n  font-family: inherit;\n  font-size: 0.875rem;\n  font-weight: 600;\n  justify-content: center;\n  line-height: 1rem;\n  min-height: 1.25rem;\n  min-width: 1.5rem;\n  padding: 0 0.3125rem;\n}\n\n.annotation kbd:not(.annotation kbd:last-of-type) {\n  margin-right: 0.25rem;\n}\n\n.annotation__icon {\n  align-items: center;\n  background-color: #f26725;\n  border-radius: 9999px;\n  box-shadow: 0 0 0 2px #fff, 0 0 0 3px #00000014, 0 1px 2px 4px #00000014;\n  display: block;\n  height: 0.875rem;\n  left: 0.5rem;\n  position: absolute;\n  transform: translate3d(-50%, -50%, 0);\n  width: 0.875rem;\n  z-index: 1;\n}\n\n.annotation__icon:hover {\n  cursor: pointer;\n  height: 1rem;\n  width: 1rem;\n}\n\n.annotation__icon:active {\n  cursor: move;\n}\n\n.annotation__popup {\n  background-clip: padding-box;\n  background-color: #fff;\n  border: 1px solid #0000001a;\n  border-radius: 12px;\n  box-shadow: 0 8px 16px #0000001a;\n  display: none;\n  left: 0.5rem;\n  position: absolute;\n  top: 0;\n  width: 18.4375rem;\n}\n\n.annotation__popup.is-visible {\n  animation: slideDown 0.4s cubic-bezier(0.19, 1, 0.22, 1);\n}\n\n@keyframes slideDown {\n  0% {\n    opacity: 0;\n    transform: translateY(-5px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.annotation--active {\n  z-index: 10;\n}\n\n.annotation--active .annotation__icon {\n  height: 1.375rem;\n  width: 1.375rem;\n}\n\n.annotation--active .annotation__popup {\n  display: block;\n}\n\n.annotation--was-active .annotation__icon {\n  background-color: #000000b3;\n}\n\n.annotation--moving .annotation__icon:hover {\n  cursor: move;\n}\n\n.annotation--moving .annotation__popup {\n  display: none;\n}\n\n.annotation__header {\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg' color='%23858585'%3E%3Cg fill='currentcolor' fill-rule='evenodd'%3E%3Ccircle cx='5' cy='12' r='2'/%3E%3Ccircle cx='12' cy='12' r='2'/%3E%3Ccircle cx='19' cy='12' r='2'/%3E%3C/g%3E%3C/svg%3E\");\n  background-position: top 1rem right 1rem;\n  background-repeat: no-repeat;\n  background-size: 1rem;\n  border-bottom: 1px solid #0000001a;\n  padding: 1.125rem 1.3125rem 1.0625rem 1.25rem;\n}\n\n.annotation__header:last-child {\n  border-bottom: none;\n}\n\n.annotation__content {\n  background-color: #00000005;\n  padding: 1.125rem 1.25rem 1.25rem;\n}\n\n.annotation__comment {\n  list-style: none;\n}\n\n.annotation__comment:not(:last-of-type) {\n  margin-bottom: 1.375rem;\n}\n\n.annotation__meta {\n  align-items: center;\n  display: flex;\n  margin-bottom: 0.25rem;\n}\n\n.annotation__avatar {\n  border-radius: 9999px;\n  height: 1rem;\n  margin-right: 0.5rem;\n  width: 1rem;\n}\n\n.annotation__author {\n  color: #000;\n  font-size: 0.8125rem;\n  font-weight: 500;\n  line-height: 1rem;\n}\n\n.annotation__timestamp {\n  color: #000000a3;\n  font-size: 0.75rem;\n  line-height: 1rem;\n  margin-left: 0.5rem;\n}\n\n.annotation__text {\n  color: #5c5c5c;\n  font-size: 0.8125rem;\n  line-height: 1.1875rem;\n}\n\n.annotation__text strong {\n  font-weight: 600;\n}\n\n.annotation__text em {\n  font-style: italic;\n}\n\n.entrance:not(.is-visible) {\n  opacity: 0;\n}\n\n.sticker-link {\n  text-align: center;\n}\n\n@media screen and (min-width: 1024px) {\n  .sticker-link {\n    align-items: center;\n    column-gap: 1.5rem;\n    display: flex;\n    text-align: left;\n  }\n}\n\n@media screen and (min-width: 768px) and (max-width: 1023px) {\n  .sticker-link {\n    line-height: 1.75rem;\n  }\n}\n\n@media screen and (max-width: 1023px) {\n  .sticker-link__image {\n    margin-bottom: 1rem;\n  }\n}\n\n.sticker-link__text {\n  text-wrap: balance;\n}\n\n@media screen and (max-width: 767px) {\n  .sticker-link__text {\n    margin-left: auto;\n    margin-right: auto;\n    max-width: 25rem;\n  }\n}\n\n.sticker-links-section__wrapper {\n  column-gap: 1.5rem;\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n@media screen and (min-width: 768px) {\n  .sticker-links-section__wrapper {\n    grid-template-columns: repeat(6, minmax(0, 1fr));\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .sticker-links-section__wrapper {\n    grid-template-columns: repeat(12, minmax(0, 1fr));\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .sticker-links-section__wrapper {\n    gap: 4rem;\n  }\n}\n\n.sticker-links-section__wrapper .sticker-link {\n  padding-left: 1.25rem;\n  padding-right: 1.25rem;\n}\n\n@media screen and (min-width: 1024px) {\n  .sticker-links-section__wrapper .sticker-link {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n}\n\n.sticker-links-section__wrapper .sticker-link:first-child {\n  grid-column: 1 / span 4;\n}\n\n@media screen and (min-width: 768px) {\n  .sticker-links-section__wrapper .sticker-link:first-child {\n    grid-column: 1 / span 3;\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .sticker-links-section__wrapper .sticker-link:first-child {\n    grid-column: 1 / span 6;\n  }\n}\n\n@media screen and (min-width: 1220px) {\n  .sticker-links-section__wrapper .sticker-link:first-child {\n    grid-column: 2 / span 5;\n  }\n}\n\n.sticker-links-section__wrapper .sticker-link:last-child {\n  grid-column: 1 / span 4;\n}\n\n@media screen and (min-width: 768px) {\n  .sticker-links-section__wrapper .sticker-link:last-child {\n    grid-column: 4 / span 3;\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .sticker-links-section__wrapper .sticker-link:last-child {\n    grid-column: 7 / span 6;\n  }\n}\n\n@media screen and (min-width: 1220px) {\n  .sticker-links-section__wrapper .sticker-link:last-child {\n    grid-column: 7 / span 5;\n  }\n}\n\n.sticker-links-section.three_items_variant .sticker-link {\n  display: unset;\n  padding: 0;\n  text-align: center;\n}\n\n@media screen and (min-width: 1220px) {\n  .sticker-links-section.three_items_variant .sticker-link {\n    align-items: center;\n    column-gap: 1.5rem;\n    display: flex;\n    text-align: left;\n  }\n}\n\n.sticker-links-section.three_items_variant .sticker-link:first-child {\n  grid-column: 1 / span 4;\n}\n\n@media screen and (min-width: 768px) {\n  .sticker-links-section.three_items_variant .sticker-link:first-child {\n    grid-column: 1 / span 2;\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .sticker-links-section.three_items_variant .sticker-link:first-child {\n    grid-column: 1 / span 4;\n  }\n}\n\n@media screen and (min-width: 1220px) {\n  .sticker-links-section.three_items_variant .sticker-link:first-child {\n    grid-column: 1 / span 4;\n  }\n}\n\n.sticker-links-section.three_items_variant .sticker-link:nth-child(2) {\n  grid-column: 1 / span 4;\n}\n\n@media screen and (min-width: 768px) {\n  .sticker-links-section.three_items_variant .sticker-link:nth-child(2) {\n    grid-column: 3 / span 2;\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .sticker-links-section.three_items_variant .sticker-link:nth-child(2) {\n    grid-column: 5 / span 4;\n  }\n}\n\n@media screen and (min-width: 1220px) {\n  .sticker-links-section.three_items_variant .sticker-link:nth-child(2) {\n    grid-column: 5 / span 4;\n  }\n}\n\n.sticker-links-section.three_items_variant .sticker-link:last-child {\n  grid-column: 1 / span 4;\n}\n\n@media screen and (min-width: 768px) {\n  .sticker-links-section.three_items_variant .sticker-link:last-child {\n    grid-column: 5 / span 2;\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .sticker-links-section.three_items_variant .sticker-link:last-child {\n    grid-column: 9 / span 4;\n  }\n}\n\n@media screen and (min-width: 1220px) {\n  .sticker-links-section.three_items_variant .sticker-link:last-child {\n    grid-column: 9 / span 4;\n  }\n}\n\n.top-bar {\n  background-color: #fff;\n  border-bottom: 1px solid #e6e6e6;\n  padding-bottom: 0.75rem;\n  padding-top: 0.75rem;\n  position: fixed;\n  text-align: center;\n  top: 0;\n  transition: transform 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);\n  visibility: hidden;\n  width: 100%;\n  z-index: 100;\n}\n\n@media percy, screen and (prefers-reduced-motion: reduce) {\n  .top-bar {\n    transition-duration: 1ms;\n  }\n}\n\n@media screen and (max-width: 1023px) {\n  .top-bar {\n    top: calc(4rem - 1px);\n  }\n}\n\n@supports (\n  (-webkit-backdrop-filter: blur(1px)) or (backdrop-filter: blur(1px))\n) {\n  .top-bar {\n    -webkit-backdrop-filter: blur(10px);\n    backdrop-filter: blur(10px);\n    background-color: #ffffffd9;\n  }\n}\n\n@media screen and (min-width: 768px) and (max-width: 1023px) {\n  .comparison-table {\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n  }\n}\n\n@media screen and (min-width: 768px) and (max-width: 1023px) and (min-width: 1024px) {\n  .comparison-table {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n}\n\n.comparison-table__row td:first-child,\n.comparison-table__row th:first-child {\n  border-radius: 6px 0 0 6px;\n}\n\n.comparison-table__row td:last-child,\n.comparison-table__row th:last-child {\n  border-radius: 0 6px 6px 0;\n}\n\n.comparison-table__row:nth-child(odd) {\n  background: #fff;\n}\n\n.comparison-table__row__cell,\n.comparison-table__row__heading {\n  font-size: 0.9375rem;\n  line-height: 1.5rem;\n}\n\n@media screen and (min-width: 1024px) {\n  .comparison-table__row__cell,\n  .comparison-table__row__heading {\n    font-size: 1rem;\n  }\n}\n\n.comparison-table__row__heading {\n  padding: 1rem 0 1rem 1.25rem;\n  text-align: left;\n  vertical-align: middle;\n}\n\n@media screen and (min-width: 1024px) {\n  .comparison-table__row__heading {\n    padding: 1rem 1.25rem;\n  }\n}\n\n.comparison-table__row__heading .tooltip {\n  margin-left: 0.25rem;\n}\n\n.comparison-table__row__heading .tooltip svg {\n  color: #000;\n  vertical-align: middle;\n}\n\n.comparison-table__row__heading .tooltip svg #background {\n  fill: #000;\n  opacity: 0.096;\n  transition: 0.25s cubic-bezier(0.455, 0.03, 0.515, 0.955);\n}\n\n.comparison-table__row__heading .pill {\n  margin-left: 0.25rem;\n}\n\n.comparison-table__row__cell {\n  font-size: 0.9375rem;\n  padding: 1rem 0;\n  text-align: center;\n  vertical-align: top;\n  width: 5.0625rem;\n}\n\n@media screen and (min-width: 768px) and (max-width: 1023px) {\n  .comparison-table__row__cell {\n    width: 8.25rem;\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .comparison-table__row__cell {\n    border-left: 1px solid #00000014;\n    vertical-align: middle;\n    width: 15rem;\n  }\n}\n\n@media screen and (min-width: 1220px) {\n  .comparison-table__row__cell {\n    width: 16.75rem;\n  }\n}\n\n.comparison-table__row__cell:not(.comparison-table__plan) {\n  color: #0000007a;\n}\n\n.comparison-table__row__cell svg {\n  color: #fff;\n  vertical-align: middle;\n}\n\n.comparison-table__row__cell--color-grey:not(.comparison-table__plan) {\n  color: #5c5c5c;\n}\n\n.comparison-table__title {\n  font-size: 2rem;\n  font-weight: 600;\n  letter-spacing: -0.5px;\n  line-height: 2.5rem;\n  text-align: left;\n}\n\n@media screen and (min-width: 1220px) {\n  .comparison-table__title {\n    font-size: 2.25rem;\n  }\n}\n\n.comparison-table__header {\n  width: 100%;\n}\n\n.comparison-table__header .comparison-table__row {\n  background: #0000;\n}\n\n.comparison-table__block {\n  margin-bottom: 1.5rem;\n  width: 100%;\n}\n\n.comparison-table__block:last-child {\n  margin-bottom: 0;\n}\n\n.comparison-table__block:nth-child(2)\n  .comparison-table__block__header\n  .comparison-table__row__cell {\n  border-left: 1px solid #00000014;\n}\n\n.comparison-table__block:not(.comparison-table__block--design)\n  .comparison-table__block__header\n  .comparison-table__row__cell {\n  border: 0;\n}\n\n.comparison-table__block__title {\n  padding: 1rem 1.25rem;\n}\n\n@media screen and (min-width: 768px) {\n  .comparison-table__block__title {\n    padding: 1rem;\n  }\n}\n\n.comparison-table__block__title h3 {\n  font-size: 1.125rem;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 1.5rem;\n  margin: 0;\n  text-align: left;\n}\n\n@media screen and (min-width: 768px) {\n  .comparison-table__block__title h3 {\n    font-size: 1.25rem;\n  }\n}\n\n.comparison-table__plan {\n  padding: 0 0.75rem 1.5rem;\n  text-align: left;\n}\n\n.comparison-table__plan:first-of-type .button {\n  background-color: #f26725;\n}\n\n.comparison-table__plan__name,\n.comparison-table__plan__price {\n  font-weight: 600;\n}\n\n.comparison-table__plan__name {\n  font-size: 1rem;\n  line-height: 1.5rem;\n}\n\n.comparison-table__plan__price {\n  font-size: 1.25rem;\n  line-height: 1.75rem;\n  margin: 0.25rem 0;\n}\n\n@media screen and (min-width: 768px) {\n  .comparison-table__plan__price {\n    display: block;\n  }\n}\n\n.comparison-table__plan__billing-mode {\n  color: #000000a3;\n  display: block;\n  font-size: 0.9375rem;\n  line-height: 1.25rem;\n}\n\n.comparison-table__plan .button {\n  margin-top: 1.5rem;\n  width: 100%;\n}\n\n.comparison-table__mobile-header__top-bar-title {\n  color: #5c5c5c;\n  display: none;\n  font-size: 1rem;\n  line-height: 1.5rem;\n}\n\n.comparison-table__mobile-header__title {\n  font-size: 2rem;\n  font-weight: 600;\n  letter-spacing: -0.5px;\n  line-height: 2.5rem;\n  margin-bottom: 1.5rem;\n  text-align: center;\n}\n\n@media screen and (max-width: 767px) {\n  .comparison-table__mobile-header__title {\n    font-size: 1.75rem;\n    line-height: 2rem;\n  }\n}\n\n.comparison-table__mobile-header__plans {\n  align-items: center;\n  display: flex;\n  gap: 0.875rem;\n  justify-content: flex-end;\n  width: 100%;\n}\n\n@media screen and (min-width: 768px) and (max-width: 1023px) {\n  .comparison-table__mobile-header__plans {\n    gap: 3.875rem;\n  }\n}\n\n.comparison-table__mobile-header__plan-name {\n  font-size: 1rem;\n  font-weight: 500;\n  line-height: 1.5rem;\n}\n\n.comparison-table__mobile-header__inner {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n}\n\n.comparison-table--static .comparison-table__mobile-header__inner {\n  padding: 1.25rem 0.25rem 1.25rem 0;\n  position: relative;\n}\n\n@media screen and (min-width: 768px) and (max-width: 1023px) {\n  .comparison-table--static .comparison-table__mobile-header__inner {\n    padding-right: 1.875rem;\n  }\n}\n\n.comparison-table--static .comparison-table__mobile-header__inner:after {\n  border-bottom: 1px solid #00000014;\n  bottom: 0;\n  content: \"\";\n  left: -1rem;\n  position: absolute;\n  width: calc(100% + 2rem);\n}\n\n.comparison-table__note {\n  color: #0000007a;\n  display: block;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1rem;\n  text-transform: uppercase;\n  text-transform: none;\n}\n\n.comparison-table .tooltip.tooltip--new:before {\n  background-color: #000c;\n  max-width: 12.5rem;\n  white-space: normal;\n  width: max-content;\n}\n\n@media screen and (min-width: 1024px) {\n  .comparison-table .tooltip.tooltip--new:before {\n    max-width: 18.75rem;\n  }\n}\n\n@media screen and (min-width: 1220px) {\n  .comparison-table .tooltip.tooltip--new:before {\n    max-width: 21.875rem;\n  }\n}\n\n@media screen and (min-width: 1024px) and (max-width: 1219px) {\n  .comparison-table--static\n    .comparison-table__header\n    .comparison-table__row__cell:last-child\n    .button {\n    margin-top: 2.75rem;\n  }\n}\n\n.comparison-table--top-bar .comparison-table__title {\n  font-size: 1.5rem;\n  line-height: 2rem;\n  padding-top: 1.5rem;\n}\n\n.comparison-table--top-bar .comparison-table__plan {\n  padding-top: 1.5rem;\n}\n\n.comparison-table--top-bar .comparison-table__plan__name {\n  font-size: 1rem;\n}\n\n.comparison-table--top-bar .comparison-table__plan__price {\n  font-size: 1.25rem;\n}\n\n.comparison-table--top-bar .button {\n  margin-top: 1rem;\n}\n\n@media screen and (min-width: 1024px) {\n  .comparison-table--no-ctas .comparison-table__row__cell {\n    width: 12.5rem;\n  }\n}\n\n@media screen and (min-width: 768px) {\n  .comparison-table--no-ctas .comparison-table__title {\n    font-size: 1.5rem;\n    font-weight: 600;\n    line-height: 2rem;\n  }\n}\n\n.comparison-table--no-ctas .comparison-table__plan {\n  vertical-align: top;\n}\n\n.comparison-table--no-ctas .comparison-table__plan .button {\n  display: none;\n}\n\n@media screen and (min-width: 768px) {\n  .comparison-table--docs {\n    padding: 0;\n  }\n}\n\n.comparison-table--docs .comparison-table__row:nth-child(odd) {\n  background: #fafafa;\n}\n\n.comparison-table--docs .comparison-table__header .comparison-table__row {\n  background: #0000;\n}\n\n@media screen and (max-width: 767px) {\n  .comparison-table--docs .tooltip.tooltip--new:before {\n    max-width: 9.375rem;\n  }\n}\n\n@media screen and (min-width: 1024px) and (max-width: 1219px) {\n  .comparison-table--docs .tooltip.tooltip--new:before {\n    max-width: 9.375rem;\n  }\n}\n\n.top-bar--comparison-table .comparison-table__mobile-header__title {\n  display: none;\n}\n\n.top-bar--comparison-table .comparison-table__mobile-header__plans {\n  width: auto;\n}\n\n.top-bar--comparison-table .comparison-table__mobile-header__inner {\n  padding: 1.25rem 1.25rem 1.25rem 1rem;\n}\n\n@media screen and (min-width: 768px) and (max-width: 1023px) {\n  .top-bar--comparison-table .comparison-table__mobile-header__inner {\n    padding-left: 2.75rem;\n    padding-right: 4.625rem;\n  }\n}\n\n.top-bar--comparison-table .comparison-table__mobile-header__top-bar-title {\n  display: block;\n}\n\n@media screen and (min-width: 1024px) {\n  .comparison-table-grid {\n    column-gap: 1.5rem;\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n}\n\n@media screen and (min-width: 1024px) and (min-width: 768px) {\n  .comparison-table-grid {\n    grid-template-columns: repeat(6, minmax(0, 1fr));\n  }\n}\n\n@media screen and (min-width: 1024px) and (min-width: 1024px) {\n  .comparison-table-grid {\n    grid-template-columns: repeat(12, minmax(0, 1fr));\n  }\n}\n\n@media screen and (max-width: 1219px) {\n  .comparison-table-grid {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n}\n\n@media screen and (max-width: 1219px) and (min-width: 640px) {\n  .comparison-table-grid {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n}\n\n@media screen and (max-width: 1219px) and (min-width: 1220px) {\n  .comparison-table-grid {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n}\n\n.comparison-table-grid .comparison-table {\n  grid-column: 1 / span 4;\n}\n\n@media screen and (min-width: 768px) {\n  .comparison-table-grid .comparison-table {\n    grid-column: 1 / span 6;\n  }\n}\n\n@media screen and (min-width: 1024px) and (max-width: 1219px) {\n  .comparison-table-grid .comparison-table {\n    grid-column: 1 / span 12;\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n  }\n}\n\n@media screen and (min-width: 1024px) and (max-width: 1219px) and (min-width: 1024px) {\n  .comparison-table-grid .comparison-table {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n}\n\n@media screen and (min-width: 1220px) {\n  .comparison-table-grid .comparison-table {\n    grid-column: 2 / span 10;\n    padding: 0;\n  }\n}\n\n.comparison-table-grid--has-blur {\n  max-height: 43.75rem;\n  overflow: hidden;\n  position: relative;\n  transition: max-height 0.4s cubic-bezier(0.455, 0.03, 0.515, 0.955);\n}\n\n.comparison-table-grid--has-blur.is-expanded {\n  max-height: 218.75rem;\n}\n\n@media screen and (min-width: 1024px) {\n  .comparison-table-grid--has-blur.is-expanded {\n    max-height: 175rem;\n  }\n}\n\n.comparison-table-grid--has-blur.is-expanded .comparison-table__blur {\n  display: none;\n}\n\n.comparison-table-grid--docs {\n  padding: 0;\n}\n\n@media screen and (min-width: 1024px) {\n  .comparison-table-grid--docs {\n    margin: 3.5rem 0;\n  }\n}\n\n.comparison-table-grid--docs .comparison-table__blur {\n  background-image: linear-gradient(0deg, #fff, #0000);\n}\n\n@media screen and (min-width: 1024px) {\n  .comparison-table-grid--docs .comparison-table {\n    grid-column: 1 / span 12;\n    padding: 0;\n  }\n}\n\n.comparison-table-grid--docs .comparison-table__mobile-header__title a {\n  display: none;\n}\n\n.comparison-table-grid--docs.is-expanded {\n  max-height: 231.25rem;\n}\n\n@media screen and (min-width: 768px) {\n  .comparison-table-grid--docs.is-expanded {\n    max-height: 181.25rem;\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .comparison-table-grid--docs.is-expanded {\n    max-height: 212.5rem;\n  }\n}\n\n@media screen and (min-width: 1220px) {\n  .comparison-table-grid--docs.is-expanded {\n    max-height: 193.75rem;\n  }\n}\n\n.comparison-table-grid--docs .comparison-table__row__heading {\n  font-weight: 400;\n}\n\n@media screen and (min-width: 1220px) {\n  .comparison-table-grid--license .comparison-table {\n    grid-column: 3 / span 8;\n  }\n}\n\n.comparison-table__blur {\n  background-image: linear-gradient(0deg, #fafafa, #0000);\n  bottom: 0;\n  height: 7.5rem;\n  left: 0;\n  position: absolute;\n  right: 0;\n}\n\n.comparison-table__blur-toggle {\n  align-items: center;\n  background: #f5f5f5;\n  border: none;\n  border-radius: 20px;\n  display: flex;\n  font-size: 1rem;\n  font-weight: 600;\n  line-height: 1.5rem;\n  margin: 2.5rem auto 0;\n  padding: 0.5rem 0.75rem;\n}\n\n.comparison-table__blur-toggle .comparison-table__blur-toggle__cross,\n.comparison-table__blur-toggle--is-expanded\n  .comparison-table__blur-toggle__plus {\n  display: none;\n}\n\n.comparison-table__blur-toggle--is-expanded\n  .comparison-table__blur-toggle__cross {\n  color: #212123;\n  display: inline-block;\n  height: 1.125rem;\n  width: 1.125rem;\n}\n\n.comparison-table__blur-toggle .comparison-table__blur-toggle__cross,\n.comparison-table__blur-toggle .comparison-table__blur-toggle__plus {\n  margin-left: 0.75rem;\n}\n\n.comparison-table-wrapper {\n  position: relative;\n}\n\n.pricing-plans {\n  align-items: flex-end;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  justify-content: center;\n}\n\n/*@media screen and (min-width:768px) {*/\n/*    .pricing-plans {*/\n/*        gap: 1.5rem*/\n/*    }*/\n/*}*/\n\n.pricing-plans__notes {\n  margin-top: 1.5rem;\n  text-align: center;\n  width: 100%;\n}\n\n@media screen and (min-width: 768px) {\n  .pricing-plans__notes {\n    margin-top: 1rem;\n  }\n}\n\n.pricing-plans__notes p {\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n}\n\n.pricing-plans__notes p:first-child {\n  margin-bottom: 0.5rem;\n}\n\n.pricing-plans__notes p:last-child {\n  color: #0000007a;\n}\n\n.pricing-plan {\n  position: relative;\n  width: 100%;\n}\n\n@media screen and (min-width: 768px) {\n  .pricing-plan {\n    width: 20.5rem;\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .pricing-plan {\n    width: 24.5rem;\n  }\n}\n\n@media screen and (min-width: 1220px) {\n  .pricing-plan {\n    width: 25.5rem;\n  }\n}\n\n.pricing-plan__box {\n  box-shadow: 0 1px 2px #00000014, 0 4px 8px #00000005;\n  height: 100%;\n  padding: 2rem 1.25rem;\n  position: relative;\n}\n\n@media screen and (min-width: 1220px) {\n  .pricing-plan__box {\n    padding: 2rem 1.5rem;\n  }\n}\n\n.pricing-plan__tags {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n@media screen and (max-width: 1023px) {\n  .pricing-plan__tags {\n    flex-wrap: wrap;\n  }\n}\n\n.pricing-plan__button {\n  display: block;\n  margin: 1.5rem auto 0.5rem;\n  text-align: center;\n  font-weight: 700;\n}\n\n@media screen and (min-width: 1024px) {\n  .pricing-plan__button {\n    width: calc(100% - 16px);\n  }\n}\n\n.pricing-plan__name {\n  font-size: 1.5rem;\n  font-weight: 600;\n  letter-spacing: -0.5px;\n  line-height: 2rem;\n}\n\n.pricing-plan__price {\n  display: block;\n  font-size: 2.75rem;\n  font-weight: 700;\n  letter-spacing: -1px;\n  line-height: 3rem;\n  margin: 1rem 0 0.75rem;\n}\n\n.pricing-plan__banner {\n  background: #0000000a;\n  border-radius: 4px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  line-height: 1.25rem;\n  margin-bottom: 0.5rem;\n  padding: 0.625rem;\n  position: relative;\n  text-align: center;\n  width: 100%;\n}\n\n.pricing-plan__banner em {\n  color: #f26725;\n  font-weight: 600;\n}\n\n.pricing-plan__banner .annotation {\n  position: absolute;\n  right: 5.875rem;\n  text-align: left;\n  top: 1rem;\n}\n\n.pricing-plan__sticker {\n  position: absolute;\n  top: 0;\n  z-index: -1;\n}\n\n@media screen and (max-width: 1023px) {\n  .pricing-plan__sticker {\n    max-width: 16rem;\n  }\n}\n\n.pricing-plan__sticker--standard {\n  left: -12.875rem;\n  top: 2.9375rem;\n}\n\n@media screen and (min-width: 768px) {\n  .pricing-plan__sticker--standard {\n    left: -11.5rem;\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .pricing-plan__sticker--standard {\n    left: -15.125rem;\n  }\n}\n\n.pricing-plan__sticker--license {\n  right: -10.8125rem;\n  top: 0;\n}\n\n@media screen and (min-width: 768px) {\n  .pricing-plan__sticker--license {\n    right: -11.4375rem;\n    top: 2.9375rem;\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .pricing-plan__sticker--license {\n    right: -16.8125rem;\n    top: 2.5rem;\n  }\n}\n\n.pricing-plan__sticker--business {\n  position: relative;\n}\n\n@media screen and (max-width: 1023px) {\n  .pricing-plan__sticker--business {\n    max-width: 13.0625rem;\n  }\n}\n\n.pricing-plan__business__button {\n  margin-top: 1.5rem;\n  text-align: center;\n  width: 100%;\n}\n\n@media screen and (min-width: 768px) {\n  .pricing-plan__business__button {\n    margin-top: 3.5rem;\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .pricing-plan__business__button {\n    margin-bottom: 0;\n    margin-top: 4rem;\n  }\n}\n\n@media screen and (min-width: 1220px) {\n  .pricing-plan__business__button {\n    margin-top: 2.5rem;\n  }\n}\n\n.pricing-plan__business__button--desktop {\n  display: none;\n}\n\n@media screen and (min-width: 768px) {\n  .pricing-plan__business__button--desktop {\n    display: block;\n  }\n\n  .pricing-plan__business__button--mobile {\n    display: none;\n  }\n\n  .pricing-plan__business__inner--left {\n    min-width: 18rem;\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .pricing-plan__business__inner--left {\n    min-width: 22.5rem;\n  }\n}\n\n.pricing-plan__business__text {\n  font-size: 1rem;\n  line-height: 1.5rem;\n}\n\n.pricing-plan__business__text strong {\n  font-weight: 600;\n}\n\n.pricing-plan__business__sticker-wrapper {\n  left: -9rem;\n  position: absolute;\n  top: 34.375rem;\n  z-index: -1;\n}\n\n@media screen and (min-width: 768px) {\n  .pricing-plan__business__sticker-wrapper {\n    left: -10rem;\n    top: 18.5625rem;\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .pricing-plan__business__sticker-wrapper {\n    left: -13.75rem;\n    top: 13.75rem;\n  }\n}\n\n@media screen and (min-width: 1220px) {\n  .pricing-plan__business__sticker-wrapper {\n    left: -15.6875rem;\n    top: 12.25rem;\n  }\n}\n\n@media screen and (max-width: 1023px) {\n  .pricing-plan__business__sticker-wrapper {\n    max-width: 13.0625rem;\n  }\n}\n\n.pricing-plan__billing--big {\n  line-height: 1.5rem;\n}\n\n.pricing-plan__billing--small {\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n}\n\n.pricing-plan__billing--small strong {\n  font-weight: 600;\n}\n\n.pricing-plan__divider-line {\n  background-color: #00000014;\n  display: block;\n  height: 1px;\n  margin: 0.75rem 0;\n}\n\n.pricing-plan__feature-group {\n  margin-bottom: 1.5rem;\n}\n\n.pricing-plan__feature-group svg {\n  margin-right: 0.5rem;\n}\n\n.pricing-plan__feature-group--excludes .pricing-plan__feature {\n  color: #5c5c5c;\n}\n\n.pricing-plan__cta-subtitle {\n  color: #000000a3;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  text-align: center;\n}\n\n.pricing-plan__features {\n  margin-top: 2rem;\n}\n\n.pricing-plan__feature-title {\n  font-weight: 600;\n}\n\n.pricing-plan__feature {\n  align-items: flex-start;\n  font-size: 0.9375rem;\n  position: relative;\n}\n\n.pricing-plan__feature__checkmark {\n  color: #fff;\n}\n\n.pricing-plan__feature__checkmark--smaller {\n  color: #0000007a;\n  height: 1.33125rem;\n  width: 1.33125rem;\n}\n\n.pricing-plan__feature__checkmark--orange {\n  color: #f26725;\n}\n\n.pricing-plan__feature__checkmark--purple {\n  color: #b620e0;\n}\n\n.pricing-plan__feature svg {\n  min-width: 1.5rem;\n}\n\n.pricing-plan__feature .tooltip__icon {\n  color: #000;\n}\n\n.pricing-plan__feature .tooltip__icon #background {\n  fill: #000;\n  opacity: 0.096;\n  transition: 0.25s cubic-bezier(0.455, 0.03, 0.515, 0.955);\n}\n\n.pricing-plan__feature--underlined {\n  stroke-dasharray: 1000;\n  stroke-dashoffset: 1000;\n  animation: dash 1.5s linear 2s forwards;\n  color: #ccc;\n  left: 2.125rem;\n  position: absolute;\n  top: 1.375rem;\n}\n\n@keyframes dash {\n  to {\n    stroke-dashoffset: 0;\n  }\n}\n\n.pricing-plan__feature--with-tooltip {\n  align-items: center;\n}\n\n.pricing-plan__feature--with-tooltip span {\n  display: flex;\n  margin-left: 0.5rem;\n}\n\n@media screen and (max-width: 1023px) {\n  .pricing-plan__feature--permissions .tooltip.tooltip--new {\n    display: none;\n  }\n}\n\n.pricing-plan__feature__tooltip.tooltip.tooltip--new:before {\n  background-color: #000c;\n  max-width: 15rem;\n  white-space: normal;\n  width: max-content;\n}\n\n.pricing-plan__feature,\n.pricing-plan__feature-title {\n  display: flex;\n  line-height: 1.5rem;\n}\n\n.pricing-plan__feature-title:not(:last-child),\n.pricing-plan__feature:not(:last-child) {\n  margin-bottom: 0.5rem;\n}\n\n@media screen and (min-width: 1024px) {\n  .pricing-plan__inner-padding {\n    padding: 0 1rem;\n  }\n}\n\n.pricing-plan .skpabloo-selection-box {\n  -webkit-backdrop-filter: blur(32px);\n  backdrop-filter: blur(32px);\n}\n\n.pricing-plan--standard .pricing-plan__button {\n  background: #f26725;\n}\n\n@media screen and (min-width: 768px) {\n  .pricing-plan--license {\n    align-self: stretch;\n    padding-top: 3rem;\n  }\n\n  .pricing-plan--license .pricing-plan__button {\n    margin-top: 5.5rem;\n  }\n}\n\n.pricing-plan--business {\n  width: 100%;\n}\n\n@media screen and (min-width: 768px) {\n  .pricing-plan--business {\n    max-width: 42.5rem;\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .pricing-plan--business {\n    max-width: 50.5625rem;\n  }\n}\n\n@media screen and (min-width: 1220px) {\n  .pricing-plan--business {\n    max-width: 52.5rem;\n  }\n}\n\n.pricing-plan--business .pricing-plan__box {\n  display: flex;\n  gap: 2rem;\n}\n\n@media screen and (max-width: 767px) {\n  .pricing-plan--business .pricing-plan__box {\n    flex-wrap: wrap;\n  }\n}\n\n@media screen and (min-width: 768px) {\n  .pricing-plan--business .pricing-plan__box {\n    gap: 4rem;\n    padding: 2rem 1.25rem;\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .pricing-plan--business .pricing-plan__box {\n    gap: 4.5625rem;\n    padding: 2.5rem 2.5rem 2.5rem 1.5rem;\n  }\n}\n\n@media screen and (min-width: 1220px) {\n  .pricing-plan--business .pricing-plan__box {\n    gap: 5.5rem;\n  }\n}\n\n.pricing-plan--business .pricing-plan__features {\n  margin-bottom: 1.5rem;\n  margin-top: 0.75rem;\n}\n\n.pricing-plan--business .pricing-plan__price {\n  margin-bottom: 1rem;\n}\n\n.pricing-plan--business .pricing-plan__feature {\n  font-size: 1rem;\n}\n\n.pricing-plan--business .skpabloo-selection-box--crosses {\n  background-image: linear-gradient(90deg, #b620e0 50%, #0000 0),\n    linear-gradient(90deg, #b620e0 50%, #0000 0),\n    linear-gradient(180deg, #b620e0 50%, #0000 0),\n    linear-gradient(180deg, #b620e0 50%, #0000 0);\n  background-position: 0 0, 0 100%, 0 0, 100% 0;\n  background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;\n  background-size: 10px 1px, 10px 1px, 1px 10px, 1px 10px;\n  border: none;\n}\n\n.pricing-plan--business\n  .skpabloo-selection-box--crosses\n  .skpabloo-selection-box__inner-box-top-left {\n  left: -0.5px;\n  top: -5px;\n}\n\n.pricing-plan--business\n  .skpabloo-selection-box--crosses\n  .skpabloo-selection-box__inner-box-top-right {\n  right: -5px;\n  top: -5px;\n}\n\n.pricing-plan--business\n  .skpabloo-selection-box--crosses\n  .skpabloo-selection-box__inner-box-bottom-left {\n  bottom: -1px;\n  left: 0;\n}\n\n.pricing-plan--business\n  .skpabloo-selection-box--crosses\n  .skpabloo-selection-box__inner-box-bottom-right {\n  bottom: -1px;\n  right: -5px;\n}\n\n.pricing-plan--business .skpabloo-selection-box__inner-box:after,\n.pricing-plan--business .skpabloo-selection-box__inner-box:before {\n  background: #b620e0;\n}\n\n.pricing-plan--business .pricing-plan__sticker {\n  transform: rotate(-15deg);\n}\n\n::selection {\n  background-color: #ffe8db;\n}\n\n.page-pricing {\n  background-color: #fafafa;\n}\n\n.page-pricing #content {\n  overflow: clip;\n}\n\n.hero {\n  padding-top: 4rem;\n  position: relative;\n}\n\n@media screen and (min-width: 768px) {\n  .hero {\n    padding-top: 6rem;\n  }\n}\n\n.hero__title-wrapper {\n  text-align: center;\n}\n\n@media screen and (max-width: 767px) {\n  .hero__title-wrapper {\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n  }\n}\n\n@media screen and (max-width: 767px) and (min-width: 1024px) {\n  .hero__title-wrapper {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n}\n\n.hero__title {\n  font-size: 4.75rem;\n  font-weight: 900;\n  letter-spacing: -0.09375rem;\n  line-height: 4.75rem;\n  margin-bottom: 1.5rem;\n}\n\n@media screen and (max-width: 767px) {\n  .hero__title {\n    font-size: 2.75rem;\n    letter-spacing: -0.0625rem;\n    line-height: 3rem;\n  }\n}\n\n@media screen and (min-width: 768px) and (max-width: 1219px) {\n  .hero__title {\n    font-size: 3.5rem;\n    line-height: 3.5rem;\n  }\n}\n\n.hero__lead {\n  text-wrap: balance;\n  font-size: 1.0625rem;\n  font-weight: 300;\n  line-height: 1.5rem;\n  margin: 0 auto 2.75rem;\n  padding-left: 1.25rem;\n  padding-right: 1.25rem;\n}\n\n@media screen and (min-width: 1024px) {\n  .hero__lead {\n    font-size: 1.25rem;\n    line-height: 1.75rem;\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n}\n\n@media screen and (min-width: 768px) {\n  .hero__lead {\n    max-width: 32.5rem;\n    padding: 0;\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .hero__lead {\n    text-wrap: initial;\n    margin-bottom: 2.25rem;\n    max-width: 40.1875rem;\n  }\n}\n\n@media screen and (min-width: 1220px) {\n  .hero__lead {\n    margin-bottom: 2.75rem;\n    max-width: 52.5rem;\n  }\n}\n\n.hero__lead strong {\n  font-weight: 600;\n}\n\n@media screen and (min-width: 768px) {\n  .hero__lead strong {\n    font-weight: 500;\n  }\n}\n\n.faq-section {\n  margin-bottom: 4rem;\n}\n\n@media screen and (min-width: 768px) {\n  .faq-section {\n    margin-bottom: 6rem;\n  }\n}\n\n.faq-section .wrapper {\n  border-bottom: 1px solid #00000014;\n  padding-bottom: 4rem;\n}\n\n@media screen and (min-width: 768px) {\n  .faq-section .wrapper {\n    padding-bottom: 6rem;\n  }\n}\n\n.faq-section__wrapper {\n  padding-top: 0;\n}\n\n@media screen and (min-width: 768px) {\n  .faq-section__content {\n    margin-top: 1.25rem;\n  }\n}\n\n.faq__item.is-active .faq__item__question,\n.faq__item__question:hover {\n  color: #f26725;\n}\n\n@media screen and (max-width: 767px) {\n  .faq-section__header__heading {\n    font-size: 1.75rem;\n    letter-spacing: -0.5px;\n    line-height: 2rem;\n    margin-bottom: 2.5rem;\n  }\n}\n\n.pricing-plans-section {\n  margin-bottom: 4rem;\n}\n\n@media screen and (min-width: 1220px) {\n  .pricing-plans-section {\n    margin-bottom: 3rem;\n  }\n\n  .comparison-table-section > .wrapper .comparison-table {\n    border-top: 1px solid #00000014;\n    padding: 4rem 0 0;\n  }\n}\n\n.comparison-table-section .top-bar {\n  -webkit-backdrop-filter: blur(40px);\n  backdrop-filter: blur(40px);\n  background: #fafafa;\n  border-bottom: 1px solid #00000014;\n  padding: 0;\n}\n\n.sticker-links-section {\n  margin-bottom: 4rem;\n  margin-top: 4rem;\n}\n\n@media screen and (min-width: 1024px) {\n  .sticker-links-section {\n    margin-bottom: 4rem;\n    margin-top: 6rem;\n  }\n}\n\n.sticker-links-section .sticker-links-section__wrapper {\n  padding-bottom: 4rem;\n  position: relative;\n}\n\n.sticker-links-section .sticker-links-section__wrapper:after {\n  border-bottom: 1px solid #00000014;\n  bottom: 0;\n  content: \"\";\n  left: 0;\n  position: absolute;\n  right: 0;\n}\n\n.sticker-links-section .sticker-link:first-child a {\n  display: block;\n}\n\n.footnote-section .wrapper {\n  border-bottom: 1px solid #00000014;\n  padding-bottom: 1.5rem;\n}\n\n.pricing__footnote {\n  color: #0000007a;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
